<template>
  <div id='questionnaire' ref="questionnaire" v-loading="isLoading" style="min-height:200px">
    <el-backtop>
      <div class="backTop">返回顶部</div>
    </el-backtop>
    <el-row class="goBackHome">
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" v-if="!$route.query.id">
        <span class="clickBack" @click="$parent.tabIndex=0"><img src="@/assets/img/back.png" alt="">返回</span>
      </el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22" v-if="roleType==2&&!$route.query.id">
        <span style="color: #333333;">我的工作台 > </span>{{quesNaireData.applyName}}
      </el-col>
    </el-row>

    <template v-if="quesNaireData">
      <el-row class="quesStartInfo" v-if="(quesNaireData.recipientPerson==null||quesNaireData.recipientPerson==''||quesNaireData.recipientPerson==userId)&&roleType==2&&this.$route.name =='AdminApplication'&&quesNaireData.applyStatus!=5&&quesNaireData.applyStatus!=4">
        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" class="applyColor">
          <el-row style="margin-bottom:10px;">
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
              公司名 :
              <span class="leftMargin">{{quesNaireData.companyName}}</span>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
              发起时间 :
              <span class="leftPadding">{{quesNaireData.createTime.substr(0,10)}}</span>
            </el-col>
          </el-row>
          <el-row>
            申请内容 : <span class="leftPadding">{{quesNaireData.applyName}}</span>
          </el-row>
        </el-col>
        <template v-if=" quesNaireData.taskStatus==2">
          <el-col class=" taskBack" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <div @click="taskBack">
              任务退回
              <img src="@/assets/img/任务退回.png" alt="">
            </div>
          </el-col>
          <el-col style="text-align:right;margin-right:20px;" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <el-button class="button add esc" @click="isSuccess(5)">同意</el-button>
            <el-button class="button esc" @click="applyVisible=true">拒绝</el-button>
          </el-col>
        </template>
        <template v-if="quesNaireData.taskStatus==1">
          <el-col class="receiveTask" :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
            <el-button class="button receive" @click="acceptTask">接受任务</el-button>
          </el-col>
        </template>
      </el-row>
      <el-row class="applyReason" v-if="roleType == 2 && $route.name == 'AdminApplication'&&remarkReason.length>0">
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">原因说明：</el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">{{remarkReason}}</el-col>
      </el-row>
    </template>
    <!-- <transition name="fade">
      <loading v-if="isLoading&&((roleType==2&&$route.name=='Management')||(roleType==3&&$route.name=='Application'))"></loading>
    </transition> -->

    <div v-if="$route.name=='Management'&&roleType==3&&(yearList == null||yearList.length==0)" class="noInfo">
      <img src="@/assets/img/no-questionnaire.png" alt="">
      暂无调查表信息！
    </div>
    <div v-else-if="$route.name=='Management'&&roleType==2&&isShowData==1" class="noInfo">
      <img src="@/assets/img/no-questionnaire.png" alt="">
      暂无调查表信息！
    </div>

    <el-tabs v-else ref="tabs" :class="{escTabs:adminPower?true:false}" @tab-click="handleYear" v-model="yearValue">
      <el-tab-pane :label="item" v-for="(item,index) in adminPower?singleYear:yearList" :key="item.id" class="tabsItem" :ref="'tabsItem'+index">
        <el-row class=" title" :class="searchBarFixed ? 'isFixed' :''">
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="12" class="titleLeft">
            <span>{{item}}年度调查表</span>
            <div class="quesstionRefuse" v-if="approverStatusTe == 4&&situationForm.saveType==2">
              <i class="el-icon-warning"></i>
              调查表审批被拒绝,请重新填写
            </div>
            <div class="quesstionPass" v-if="approverStatusTe == 5&&situationForm.saveType==2">
              <i class="el-icon-success"></i>
              调查表已通过
            </div>
          </el-col>
          <!-- approverStatusTe---审批状态：1.申请添加中，2.申请修改中，3.申请删除中，4.审批驳回 5.审批通过 -->
          <!-- saveType---保存状态：1.保存，2.提交 -->
          <!-- <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-if="roleType==3&&isShowSubmit==1&&$route.name=='Management'"> -->
          <el-col :xs="12" :sm="12" :md="12" :lg="16" :xl="12" v-if="roleType==3&&$route.name=='Management'">
            <!-- v-if="((approverStatusTe == 1 || approverStatusTe ==2)&&situationForm.saveType==1) || approverStatusTe ==3||approverStatusTe == 4 ||approverStatusTe==null" -->
            <!-- 调查表已通过 还可以继续编辑 -->

            <el-col v-if="(approverStatusTe == 1 || approverStatusTe ==2 || approverStatusTe ==3)&&situationForm.saveType==2">
              <el-tag class="quesTips"><i class="el-icon-warning"></i><span style="color:#666;margin-left:10px;">协会工作人员正在审核中</span></el-tag>
            </el-col>
            <!-- 操作按钮，只有审核中不显示 -->
            <el-col v-else>
              <el-button class="button save" v-if="isEdit" @click="editInfo">编辑</el-button>
              <el-button class="button btn-disabled" v-else>编辑</el-button>

              <el-button class="button save" v-if="isSave" @click="saveInfo(item,index)">保存</el-button>
              <el-button class="button btn-disabled" v-else>保存</el-button>

              <el-button class="button export save" v-if="isSubmit" @click="submitInfo(item,index)">保存并提交</el-button>
              <el-button class="button export btn-disabled" v-else>保存并提交</el-button>

              <el-button class="button export btn-disabled" v-if="!isSave">导入调查表</el-button>
              <el-upload style="display: inline-block;" class="noneUpload" action="#" ref="upload" :before-upload="beforeUpload" :limit="1" :http-request="httpRequest" :file-list="fileList" v-else>
                <el-popover popper-class="quesTips" placement="top-start" width="200" trigger="hover" :close-delay="10000">
                  <el-row>
                    <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                      <img src="@/assets/img/提示.png" alt="">
                    </el-col>
                    <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21" class="textTips">
                      导入调查表后仍需要点击"<b>保存并提交</b>"按钮，提交给协会审核
                    </el-col>
                  </el-row>
                  <el-button class="button save export" slot="reference">导入调查表</el-button>
                </el-popover>
              </el-upload>
              <el-link class="linkStyle" :href="`${publicPath}file/调查表模板.xlsx`" download="调查表模板.xlsx">下载调查表模板</el-link>
            </el-col>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-form ref="situationForm" :model="situationForm" :rules="situationFormRules" label-width="180px" class="situationForm" :disabled="isDisabled" label-position="left">
          <el-tabs class="nav " id="nav" v-model="activeName" @tab-click="navClick" v-if="(roleType==2&&($route.name=='Management'||$route.name=='AdminApplication'))||(roleType==3&&$route.name=='Application')">
            <!-- 管理员--基本情况 -->
            <el-tab-pane name="1">
              <span slot="label" class="content"><img src="@/assets/img/基本情况.png" alt="">基本情况</span>
              <h3>基本情况</h3>
              <el-divider></el-divider>
              <el-row class="itemCommon">
                <el-form-item label="公司名" class="itemOne">
                  <span :class="quesNaireData?'changes-item-fixedw':''">{{situationForm.companyName}}</span>
                  <span class="before-changes-item" v-if="compareNewOld(situationForm.companyName, oldDataBeforeChange.companyName)">（修改前：{{oldDataBeforeChange.companyName}}）</span>
                </el-form-item>
                <el-form-item label="组织机构代码" class="itemOne">
                  <span :class="quesNaireData?'changes-item-fixedw':''">{{situationForm.organizationCode}}</span>
                  <span class="before-changes-item" v-if="compareNewOld(situationForm.organizationCode, oldDataBeforeChange.organizationCode)">（修改前：{{oldDataBeforeChange.organizationCode}}）</span>
                </el-form-item>
              </el-row>
              <el-row class="itemCommon mainProduct">
                <el-form-item label="主要业务活动(或主要产品)">
                  <el-checkbox-group v-model="situationForm.product">

                    <p v-if="checkedOneShow || checkedTwoShow">基础信息服务</p>
                    <el-checkbox label="信用调查与服务" v-if="checkedOneShow">
                      信用调查与服务
                      <el-popover placement="top-start" width="200" trigger="hover" content="包含企业信用服务、个人信用服务">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="公共信用管理服务" v-if="checkedTwoShow">
                      公共信用管理服务
                      <el-popover placement="top-start" width="200" trigger="hover" content="包含社会信用管理服务、行业信用管理服务">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <p v-if="checkedThreeShow || checkedFourShow || checkedFiveShow || checkedSixShow || checkedSevenShow">增值信用服务</p>
                    <!-- <el-checkbox label="增值信用服务"></el-checkbox> -->
                    <el-checkbox label="信用评价" v-if="checkedThreeShow">
                      信用评价
                      <el-popover placement="top-start" width="200" trigger="hover" content="包含工商企业信用评价服务、金融机构信用评价服务、结构融资评价、公共融资信用评价服务、主权信用评价服务">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="信用担保" v-if="checkedFourShow"></el-checkbox>
                    <el-checkbox label="保理" v-if="checkedFiveShow">
                      保理
                      <el-popover placement="top-start" width="200" trigger="hover" content="包含银行保理、商业保理">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="信用保险服务" v-if="checkedSixShow">
                      信用保险服务
                      <el-popover placement="top-start" width="200" trigger="hover" content="商业信用保险服务、出口信用保险服务">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="商账管理服务" v-if="checkedSevenShow"></el-checkbox>
                    <p v-if="checkedEightShow || checkedNineShow">衍生信用服务</p>
                    <!-- <el-checkbox label="衍生信用服务"></el-checkbox> -->
                    <el-checkbox label="大数据信用信息服务" v-if="checkedEightShow">
                      大数据信用信息服务
                      <el-popover placement="top-start" width="200" trigger="hover" content=包含信用信息整理与清洗、信用信息挖掘与分析、互联网金融信用服务>
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="信用管理咨询" v-if="checkedNineShow">
                      信用管理咨询
                      <el-popover placement="top-start" width="200" trigger="hover" content=包含信用信息场景应用、信用预警、信用培训服务、信用信息安全管理>
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                  </el-checkbox-group>
                  <span class="before-changes-item product-fixed" v-if="compareNewOld(situationForm.product, oldDataBeforeChange.product)">（修改前：
                    <span v-for="(item,index) in oldDataBeforeChange.product" :key="index">{{item}}
                      {{oldDataBeforeChange.product.length == 1 || index == (oldDataBeforeChange.product.length -1)?'':'、'}}
                    </span>
                    ）
                  </span>
                </el-form-item>
              </el-row>
              <el-row class="itemCommon">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="法定代表人(单位负责人)：" class="itemThree">
                    <span class="changes-item-fixedw">{{situationForm.legalRepresentative}}</span>
                    <span class="before-changes-item" v-if="compareNewOld(situationForm.legalRepresentative, oldDataBeforeChange.legalRepresentative)">（修改前：{{oldDataBeforeChange.legalRepresentative}}）</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="开业(成立)时间：">
                    <span class="changes-item-fixedw">{{situationForm.openTime}}</span>
                    <span class="before-changes-item" v-if="compareNewOld(situationForm.openTime, oldDataBeforeChange.openTime)">（修改前：{{oldDataBeforeChange.openTime}}）</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="itemCommon">
                <el-form-item label="单位经营地址" class="itemFive" prop="busAddress">
                  <el-table :data="situationForm.busAddress" stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="80">
                    </el-table-column>
                    <el-table-column prop="address" label="具体地址">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-row>
              <el-row class="itemCommon">
                <el-form-item prop="legalPersonList" label="下一级法人单位情况：">
                  <el-table :data="unitInfoArr" stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="80">
                    </el-table-column>
                    <el-table-column prop="organizationCode" label="组织机构代码">
                    </el-table-column>
                    <el-table-column prop="unitName" label="单位详细名称">
                    </el-table-column>
                    <el-table-column prop="legalRepresentative" label="详细地址">
                    </el-table-column>
                    <el-table-column prop="contactPhone" label="联系电话">
                    </el-table-column>
                  </el-table>
                  <el-pagination @current-change="nextUnitChange" :current-page.sync="nextUnitPageNumber" :page-size="nextUnitPageSize" layout="total, prev, pager, next" :total="nextUnitTotal">
                  </el-pagination>
                </el-form-item>
              </el-row>
              <el-row class="itemCommon">
                <el-form-item label="企业控股情况" v-if="roleType==2&&$route.name=='Management'">
                  <span>{{situationForm.enterpriseHoldingType}}</span>
                </el-form-item>
              </el-row>
            </el-tab-pane>
            <!-- 管理员--从业人员情况 -->
            <el-tab-pane name="2">
              <div slot="label" class="content"><img src="@/assets/img/从业人员.png" alt="">从业人员情况</div>
              <h3>从业情况</h3>
              <el-divider></el-divider>
              <el-row class="itemCommon ">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="年末从业人员数">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.employeesYearEndNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.employeesYearEndNumber, oldDataBeforeChange.employeesYearEndNumber)">（修改前：{{oldDataBeforeChange.employeesYearEndNumber==null?0:oldDataBeforeChange.employeesYearEndNumber}}）</span>
                    </el-col>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row class="congye">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColone">
                  <h4>按学历分:</h4>
                  <el-form-item label="研究生以上及学历">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.masterDegreeOrAboveNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.masterDegreeOrAboveNumber, oldDataBeforeChange.masterDegreeOrAboveNumber)">（修改前：{{oldDataBeforeChange.masterDegreeOrAboveNumber==null?0:oldDataBeforeChange.masterDegreeOrAboveNumber}}）</span>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="大学本科学历">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.bachelorDegreeNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.bachelorDegreeNumber, oldDataBeforeChange.bachelorDegreeNumber)">（修改前：{{oldDataBeforeChange.bachelorDegreeNumber==null?0:oldDataBeforeChange.bachelorDegreeNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="大专学历">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.collegeDegreeNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.collegeDegreeNumber, oldDataBeforeChange.collegeDegreeNumber)">（修改前：{{oldDataBeforeChange.collegeDegreeNumber==null?0:oldDataBeforeChange.collegeDegreeNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="高中及以下学历" prop="highSchoolDegreeOrBelowNumber">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.highSchoolDegreeOrBelowNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.highSchoolDegreeOrBelowNumber, oldDataBeforeChange.highSchoolDegreeOrBelowNumber)">（修改前：{{oldDataBeforeChange.highSchoolDegreeOrBelowNumber==null?0:oldDataBeforeChange.highSchoolDegreeOrBelowNumber}}）</span>
                    </el-col>

                  </el-form-item>
                </el-col>
                <span class="line"></span>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                  <h4>按从业年限分:</h4>
                  <el-form-item label="五年以上">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.fiveYearAndAboveNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.fiveYearAndAboveNumber, oldDataBeforeChange.fiveYearAndAboveNumber)">（修改前：{{oldDataBeforeChange.fiveYearAndAboveNumber==null?0:oldDataBeforeChange.fiveYearAndAboveNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="三年以上五年以下">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.threeYearsFiveNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.threeYearsFiveNumber, oldDataBeforeChange.threeYearsFiveNumber)">（修改前：{{oldDataBeforeChange.threeYearsFiveNumber==null?0:oldDataBeforeChange.threeYearsFiveNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="一年以上三年以下">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.oneYearThreeNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.oneYearThreeNumber, oldDataBeforeChange.oneYearThreeNumber)">（修改前：{{oldDataBeforeChange.oneYearThreeNumber==null?0:oldDataBeforeChange.oneYearThreeNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="一年以下">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.followingYearNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.followingYearNumber, oldDataBeforeChange.followingYearNumber)">（修改前：{{oldDataBeforeChange.followingYearNumber==null?0:oldDataBeforeChange.followingYearNumber}}）</span>
                    </el-col>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row class="congye">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColone">
                  <h4>拥有专业技术职称人数,其中:</h4>
                  <el-form-item label="高级技术职称">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.seniorTechnicalNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.seniorTechnicalNumber, oldDataBeforeChange.seniorTechnicalNumber)">（修改前：{{oldDataBeforeChange.seniorTechnicalNumber==null?0:oldDataBeforeChange.seniorTechnicalNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="中级技术职称">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.intermediateTechnicalNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.intermediateTechnicalNumber, oldDataBeforeChange.intermediateTechnicalNumber)">（修改前：{{oldDataBeforeChange.intermediateTechnicalNumber==null?0:oldDataBeforeChange.intermediateTechnicalNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="初级及以下技术职称">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.juniorBelowTechnicalNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.juniorBelowTechnicalNumber, oldDataBeforeChange.juniorBelowTechnicalNumber)">（修改前：{{oldDataBeforeChange.juniorBelowTechnicalNumber==null?0:oldDataBeforeChange.juniorBelowTechnicalNumber}}）</span>
                    </el-col>

                  </el-form-item>
                </el-col>
                <span class="line"></span>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                  <h4>持有国内职业证书人数,其中:</h4>
                  <el-form-item label="注册会计师">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.certifiedAccountantNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.certifiedAccountantNumber, oldDataBeforeChange.certifiedAccountantNumber)">（修改前：{{oldDataBeforeChange.certifiedAccountantNumber==null?0:oldDataBeforeChange.certifiedAccountantNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="具证券从业资格人员">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.personnelSecuritiesNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.personnelSecuritiesNumber, oldDataBeforeChange.personnelSecuritiesNumber)">（修改前：{{oldDataBeforeChange.personnelSecuritiesNumber==null?0:oldDataBeforeChange.personnelSecuritiesNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="具律师从业资格人员">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.personsQualifiedLawyersNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.personsQualifiedLawyersNumber, oldDataBeforeChange.personsQualifiedLawyersNumber)">（修改前：{{oldDataBeforeChange.personsQualifiedLawyersNumber==null?0:oldDataBeforeChange.personsQualifiedLawyersNumber}}）</span>
                    </el-col>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row class="congye">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColone">
                  <h4>持有国外证书人数,其中:</h4>
                  <el-form-item label="特许金融分析师(CFA)">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.charteredFinancialAnalystNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.charteredFinancialAnalystNumber, oldDataBeforeChange.charteredFinancialAnalystNumber)">（修改前：{{oldDataBeforeChange.charteredFinancialAnalystNumber==null?0:oldDataBeforeChange.charteredFinancialAnalystNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="英国特许公认会计师(ACCA)">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.charteredCertifiedAccountantsNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.charteredCertifiedAccountantsNumber, oldDataBeforeChange.charteredCertifiedAccountantsNumber)">（修改前：{{oldDataBeforeChange.charteredCertifiedAccountantsNumber==null?0:oldDataBeforeChange.charteredCertifiedAccountantsNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="美国注册会计师(AICPA)">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.americanCertifiedAccountantNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.americanCertifiedAccountantNumber, oldDataBeforeChange.americanCertifiedAccountantNumber)">（修改前：{{oldDataBeforeChange.americanCertifiedAccountantNumber==null?0:oldDataBeforeChange.americanCertifiedAccountantNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="国际注册信用分析师(CICA)">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.internationalRegisteredCreditAnalystNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.internationalRegisteredCreditAnalystNumber, oldDataBeforeChange.internationalRegisteredCreditAnalystNumber)">（修改前：{{oldDataBeforeChange.internationalRegisteredCreditAnalystNumber==null?0:oldDataBeforeChange.internationalRegisteredCreditAnalystNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="国际注册信用师(ICCA)">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.internationalRegisteredCreditOfficerNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.internationalRegisteredCreditOfficerNumber, oldDataBeforeChange.internationalRegisteredCreditOfficerNumber)">（修改前：{{oldDataBeforeChange.internationalRegisteredCreditOfficerNumber==null?0:oldDataBeforeChange.internationalRegisteredCreditOfficerNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="国际信用管理师(ICM)">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.internationalCreditManagerIcmNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.internationalCreditManagerIcmNumber, oldDataBeforeChange.internationalCreditManagerIcmNumber)">（修改前：{{oldDataBeforeChange.internationalCreditManagerIcmNumber==null?0:oldDataBeforeChange.internationalCreditManagerIcmNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="国际信用管理员(ICA)">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.internationalCreditManagerIcaNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.internationalCreditManagerIcaNumber, oldDataBeforeChange.internationalCreditManagerIcaNumber)">（修改前：{{oldDataBeforeChange.internationalCreditManagerIcaNumber==null?0:oldDataBeforeChange.internationalCreditManagerIcaNumber}}）</span>
                    </el-col>

                  </el-form-item>

                </el-col>
                <span class="line"></span>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                  <h4>持有国内培训证书人数,其中:</h4>
                  <el-form-item label="信用管理师">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.creditManagerNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.creditManagerNumber, oldDataBeforeChange.creditManagerNumber)">（修改前：{{oldDataBeforeChange.creditManagerNumber==null?0:oldDataBeforeChange.creditManagerNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="获信用管理岗位证书人员">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.staffCreditManagementCertificateNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.staffCreditManagementCertificateNumber, oldDataBeforeChange.staffCreditManagementCertificateNumber)">（修改前：{{oldDataBeforeChange.staffCreditManagementCertificateNumber==null?0:oldDataBeforeChange.staffCreditManagementCertificateNumber}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="注册咨询师">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.registeredConsultantNumber}}</span> 人
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.registeredConsultantNumber, oldDataBeforeChange.registeredConsultantNumber)">（修改前：{{oldDataBeforeChange.registeredConsultantNumber==null?0:oldDataBeforeChange.registeredConsultantNumber}}）</span>
                    </el-col>

                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <!-- 管理员--财务状况 -->
            <el-tab-pane name="3">
              <span slot="label" class="content"><img src="@/assets/img/财务.png" alt="">财务状况</span>
              <h3>财务状况 </h3>
              <el-divider></el-divider>
              <el-row class="itemCommon ">
                <h4 style="margin-bottom:20px;">资产负债:</h4>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="资产总计">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.totalAssetsAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.totalAssetsAmount, oldDataBeforeChange.totalAssetsAmount)">（修改前：{{oldDataBeforeChange.totalAssetsAmount==null?0:oldDataBeforeChange.totalAssetsAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="负债合计">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.totalLiabilitiesAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.totalLiabilitiesAmount, oldDataBeforeChange.totalLiabilitiesAmount)">（修改前：{{oldDataBeforeChange.totalLiabilitiesAmount==null?0:oldDataBeforeChange.totalLiabilitiesAmount}}）</span>
                    </el-col>

                  </el-form-item>

                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="税前利润">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.preTaxProfitsAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.preTaxProfitsAmount, oldDataBeforeChange.preTaxProfitsAmount)">（修改前：{{oldDataBeforeChange.preTaxProfitsAmount==null?0:oldDataBeforeChange.preTaxProfitsAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="营业收入">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.operatingIncome}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.operatingIncome, oldDataBeforeChange.operatingIncome)">（修改前：{{oldDataBeforeChange.operatingIncome==null?0:oldDataBeforeChange.operatingIncome}}）</span>
                    </el-col>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="itemCommon">
                <h4 style="margin-bottom:20px;">损益及分配:</h4>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-if="situationForm.product">
                  <el-form-item label="信用调查与服务业务" v-if="checkedOne||situationForm.product?situationForm.product.includes('信用调查与服务'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.creditInvestigationServiceAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.creditInvestigationServiceAmount, oldDataBeforeChange.creditInvestigationServiceAmount)">（修改前：{{oldDataBeforeChange.creditInvestigationServiceAmount==null?0:oldDataBeforeChange.creditInvestigationServiceAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="公共信用管理服务业务" v-if="checkedTwo||situationForm.product?situationForm.product.includes('公共信用管理服务'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.publicCreditManagementServiceAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.publicCreditManagementServiceAmount, oldDataBeforeChange.publicCreditManagementServiceAmount)">（修改前：{{oldDataBeforeChange.publicCreditManagementServiceAmount==null?0:oldDataBeforeChange.publicCreditManagementServiceAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="信用评价业务" v-if="checkedThree||situationForm.product?situationForm.product.includes('信用评价'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.creditRatingServiceAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.creditRatingServiceAmount, oldDataBeforeChange.creditRatingServiceAmount)">（修改前：{{oldDataBeforeChange.creditRatingServiceAmount==null?0:oldDataBeforeChange.creditRatingServiceAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="信用担保业务" v-if="checkedFour||situationForm.product?situationForm.product.includes('信用担保'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.creditGuaranteeBusinessAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.creditGuaranteeBusinessAmount, oldDataBeforeChange.creditGuaranteeBusinessAmount)">（修改前：{{oldDataBeforeChange.creditGuaranteeBusinessAmount==null?0:oldDataBeforeChange.creditGuaranteeBusinessAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="保理业务" v-if="checkedFive||situationForm.product?situationForm.product.includes('保理'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.commercialFactoringAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.commercialFactoringAmount, oldDataBeforeChange.commercialFactoringAmount)">（修改前：{{oldDataBeforeChange.commercialFactoringAmount==null?0:oldDataBeforeChange.commercialFactoringAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="信用保险服务业务" v-if="checkedSix||situationForm.product?situationForm.product.includes('信用保险服务'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.creditInsuranceServiceAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.creditInsuranceServiceAmount, oldDataBeforeChange.creditInsuranceServiceAmount)">（修改前：{{oldDataBeforeChange.creditInsuranceServiceAmount==null?0:oldDataBeforeChange.creditInsuranceServiceAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="商账管理服务业务" v-if="checkedSeven||situationForm.product?situationForm.product.includes('商账管理服务'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.businessAccountManagementServiceAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.businessAccountManagementServiceAmount, oldDataBeforeChange.businessAccountManagementServiceAmount)">（修改前：{{oldDataBeforeChange.businessAccountManagementServiceAmount==null?0:oldDataBeforeChange.businessAccountManagementServiceAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="大数据信用信息服务业务" v-if="checkedEight||situationForm.product?situationForm.product.includes('大数据信用信息服务'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.creditServiceAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.creditServiceAmount, oldDataBeforeChange.creditServiceAmount)">（修改前：{{oldDataBeforeChange.creditServiceAmount==null?0:oldDataBeforeChange.creditServiceAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="信用管理咨询业务" v-if="checkedNine||situationForm.product?situationForm.product.includes('信用管理咨询'):''">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.creditManagementServiceAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.creditManagementServiceAmount, oldDataBeforeChange.creditManagementServiceAmount)">（修改前：{{oldDataBeforeChange.creditManagementServiceAmount==null?0:oldDataBeforeChange.creditManagementServiceAmount}}）</span>
                    </el-col>

                  </el-form-item>
                  <el-form-item label="其他业务收入">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.otherBusinessAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.otherBusinessAmount, oldDataBeforeChange.otherBusinessAmount)">（修改前：{{oldDataBeforeChange.otherBusinessAmount==null?0:oldDataBeforeChange.otherBusinessAmount}}）</span>
                    </el-col>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="itemCommon">
                <el-form-item label="其他业务内容描述说明">

                  <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <span>{{situationForm.operatingProfitAmount}}</span> 千元
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                    <span class="before-changes-item" v-if="compareNewOld(situationForm.operatingProfitAmount, oldDataBeforeChange.operatingProfitAmount)">（修改前：{{oldDataBeforeChange.operatingProfitAmount==null?0:oldDataBeforeChange.operatingProfitAmount}}）</span>
                  </el-col>

                </el-form-item>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="净利润">

                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                      <span>{{situationForm.operatingProfitAmount}}</span> 千元
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <span class="before-changes-item" v-if="compareNewOld(situationForm.operatingProfitAmount, oldDataBeforeChange.operatingProfitAmount)">（修改前：{{oldDataBeforeChange.operatingProfitAmount==null?0:oldDataBeforeChange.operatingProfitAmount}}）</span>
                    </el-col>

                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <!-- 管理员--业务状况 -->
            <el-tab-pane name="4">
              <span slot="label" class="content fare"><img src="@/assets/img/业务.png" alt="">业务状况</span>
              <h3>业务状况 </h3>
              <el-divider></el-divider>
              <template v-if="checkedOne||checkedTwo||(situationForm.product?situationForm.product.includes('信用调查与服务'):'')||(situationForm.product?situationForm.product.includes('公共信用管理服务'):'')">
                <h3>基础信用服务</h3>
                <el-divider></el-divider>
                <template v-if=" checkedOne||situationForm.product?situationForm.product.includes('信用调查与服务'):''">
                  <h4 class="titleTwo">信用调查与服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColone">
                      <h4>企业信用服务</h4>
                      <el-form-item label="信用报告出具数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.companyCreditReportNumber}}</span> 份
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.companyCreditReportNumber, oldDataBeforeChange.companyCreditReportNumber)">（修改前：{{oldDataBeforeChange.companyCreditReportNumber==null?0:oldDataBeforeChange.companyCreditReportNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="其他征信服务产品提供次数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.companyOtherCreditProductNumber}}</span> 份
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.companyOtherCreditProductNumber, oldDataBeforeChange.companyOtherCreditProductNumber)">（修改前：{{oldDataBeforeChange.companyOtherCreditProductNumber==null?0:oldDataBeforeChange.companyOtherCreditProductNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="客户数量">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.companyCustomerNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.companyCustomerNumber, oldDataBeforeChange.companyCustomerNumber)">（修改前：{{oldDataBeforeChange.companyCustomerNumber==null?0:oldDataBeforeChange.companyCustomerNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>个人信用服务</h4>
                      <el-form-item label="信用报告出具数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.personalCreditReportNumber}}</span> 份
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.personalCreditReportNumber, oldDataBeforeChange.personalCreditReportNumber)">（修改前：{{oldDataBeforeChange.personalCreditReportNumber==null?0:oldDataBeforeChange.personalCreditReportNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="客户数量">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.personalCustomerNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.personalCustomerNumber, oldDataBeforeChange.personalCustomerNumber)">（修改前：{{oldDataBeforeChange.personalCustomerNumber==null?0:oldDataBeforeChange.personalCustomerNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedTwo||situationForm.product?situationForm.product.includes('公共信用管理服务'):''">
                  <h4 class="titleTwo">公共信用管理服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>社会信用管理服务</h4>
                      <el-form-item label="服务政府项目数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.socialGovernmentProjectNumber}}</span> 次
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.socialGovernmentProjectNumber, oldDataBeforeChange.socialGovernmentProjectNumber)">（修改前：{{oldDataBeforeChange.socialGovernmentProjectNumber==null?0:oldDataBeforeChange.socialGovernmentProjectNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>行业信用管理服务</h4>
                      <el-form-item label="服务行业协会项目数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.industryServiceIndustryNumber}}</span> 次
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.industryServiceIndustryNumber, oldDataBeforeChange.industryServiceIndustryNumber)">（修改前：{{oldDataBeforeChange.industryServiceIndustryNumber==null?0:oldDataBeforeChange.industryServiceIndustryNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </template>
              <template v-if="checkedThree||checkedFour||checkedFive||checkedSix||checkedSeven||(situationForm.product?situationForm.product.includes('信用评价'):'')||(situationForm.product?situationForm.product.includes('信用担保'):'')||(situationForm.product?situationForm.product.includes('保理'):'')||(situationForm.product?situationForm.product.includes('信用保险服务'):'')||(situationForm.product?situationForm.product.includes('商账管理服务'):'')">
                <h3>增值信用服务</h3>
                <el-divider></el-divider>
                <template v-if="checkedThree||situationForm.product?situationForm.product.includes('信用评价'):''">
                  <h4 class="titleTwo">信用评价</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>工商企业信用评价服务</h4>
                      <el-form-item label="评价数量">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.industryRatingNumber}}</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.industryRatingNumber, oldDataBeforeChange.industryRatingNumber)">（修改前：{{oldDataBeforeChange.industryRatingNumber==null?0:oldDataBeforeChange.industryRatingNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <h4>结构融资评价</h4>
                      <el-form-item label="评价数量">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.structuredRatingNumber}}</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.structuredRatingNumber, oldDataBeforeChange.structuredRatingNumber)">（修改前：{{oldDataBeforeChange.structuredRatingNumber==null?0:oldDataBeforeChange.structuredRatingNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <h4>主权信用评价服务</h4>
                      <el-form-item label="评价数量">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.sovereignRatingNumber}}</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.sovereignRatingNumber, oldDataBeforeChange.sovereignRatingNumber)">（修改前：{{oldDataBeforeChange.sovereignRatingNumber==null?0:oldDataBeforeChange.sovereignRatingNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>金融机构信用评价服务</h4>
                      <el-form-item label="评价数量">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.financialRatingNumber}}</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.financialRatingNumber, oldDataBeforeChange.financialRatingNumber)">（修改前：{{oldDataBeforeChange.financialRatingNumber==null?0:oldDataBeforeChange.financialRatingNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <h4>公共融资信用评价服务</h4>
                      <el-form-item label="评价数量">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.publicRatingNumber}}</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.publicRatingNumber, oldDataBeforeChange.publicRatingNumber)">（修改前：{{oldDataBeforeChange.publicRatingNumber==null?0:oldDataBeforeChange.publicRatingNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedFour||situationForm.product?situationForm.product.includes('信用担保'):''">
                  <h4 class="titleTwo">信用担保</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="担保数量">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.guaranteeNumber}}</span> 笔
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.guaranteeNumber, oldDataBeforeChange.guaranteeNumber)">（修改前：{{oldDataBeforeChange.guaranteeNumber==null?0:oldDataBeforeChange.guaranteeNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <el-form-item label="担保金额合计">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.totalGuaranteeAmount}}</span> 千元
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.totalGuaranteeAmount, oldDataBeforeChange.totalGuaranteeAmount)">（修改前：{{oldDataBeforeChange.totalGuaranteeAmount==null?0:oldDataBeforeChange.totalGuaranteeAmount}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedFive||situationForm.product?situationForm.product.includes('保理'):''">
                  <h4 class="titleTwo">保理</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>银行保理</h4>
                      <el-form-item label="保理业务发生笔数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.bankFactoringNumber}}</span> 笔
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.bankFactoringNumber, oldDataBeforeChange.bankFactoringNumber)">（修改前：{{oldDataBeforeChange.bankFactoringNumber==null?0:oldDataBeforeChange.bankFactoringNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="保理业务发生额">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.bankFactoringIncurredAmount}}</span> 千元
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.bankFactoringIncurredAmount, oldDataBeforeChange.bankFactoringIncurredAmount)">（修改前：{{oldDataBeforeChange.bankFactoringIncurredAmount==null?0:oldDataBeforeChange.bankFactoringIncurredAmount}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>商业保理</h4>
                      <el-form-item label="保理业务发生笔数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.commercialFactoringNumber}}</span> 笔
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.commercialFactoringNumber, oldDataBeforeChange.commercialFactoringNumber)">（修改前：{{oldDataBeforeChange.commercialFactoringNumber==null?0:oldDataBeforeChange.commercialFactoringNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="保理业务发生额">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.commercialFactoringIncurredAmount}}</span> 千元
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.commercialFactoringIncurredAmount, oldDataBeforeChange.commercialFactoringIncurredAmount)">（修改前：{{oldDataBeforeChange.commercialFactoringIncurredAmount==null?0:oldDataBeforeChange.commercialFactoringIncurredAmount}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedSix||situationForm.product?situationForm.product.includes('信用保险服务'):''">
                  <h4 class="titleTwo">信用保险服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>商业信用保险服务</h4>
                      <el-form-item label="保单数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.commercialPoliciesNumber}}</span> 笔
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.commercialPoliciesNumber, oldDataBeforeChange.commercialPoliciesNumber)">（修改前：{{oldDataBeforeChange.commercialPoliciesNumber==null?0:oldDataBeforeChange.commercialPoliciesNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="承保金额合计">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.commercialTotalInsuredAmount}}</span> 千元
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.commercialTotalInsuredAmount, oldDataBeforeChange.commercialTotalInsuredAmount)">（修改前：{{oldDataBeforeChange.commercialTotalInsuredAmount==null?0:oldDataBeforeChange.commercialTotalInsuredAmount}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>出口信用保险服务</h4>
                      <el-form-item label="保单数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.exportPoliciesNumber}}</span> 笔
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.exportPoliciesNumber, oldDataBeforeChange.exportPoliciesNumber)">（修改前：{{oldDataBeforeChange.exportPoliciesNumber==null?0:oldDataBeforeChange.exportPoliciesNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="承保金额合计">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.exportTotalInsuredAmount}}</span> 千元
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.exportTotalInsuredAmount, oldDataBeforeChange.exportTotalInsuredAmount)">（修改前：{{oldDataBeforeChange.exportTotalInsuredAmount==null?0:oldDataBeforeChange.exportTotalInsuredAmount}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedSeven||situationForm.product?situationForm.product.includes('商账管理服务'):''">
                  <h4 class="titleTwo">商账管理服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="应收账委托金额合计">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.totalEntrustmentAmount}}</span> 千元
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.totalEntrustmentAmount, oldDataBeforeChange.totalEntrustmentAmount)">（修改前：{{oldDataBeforeChange.totalEntrustmentAmount==null?0:oldDataBeforeChange.totalEntrustmentAmount}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <el-form-item label="应收账款回收金额合计">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.totalReceivablesAmount}}</span> 千元
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.totalReceivablesAmount, oldDataBeforeChange.totalReceivablesAmount)">（修改前：{{oldDataBeforeChange.totalReceivablesAmount==null?0:oldDataBeforeChange.totalReceivablesAmount}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>

              </template>
              <template v-if="checkedEight||checkedNine||(situationForm.product?situationForm.product.includes('大数据信用信息服务'):'')||(situationForm.product?situationForm.product.includes('信用管理咨询'):'')">
                <h3>衍生信用服务</h3>
                <el-divider></el-divider>
                <template v-if="checkedEight||situationForm.product?situationForm.product.includes('大数据信用信息服务'):''">
                  <h4 class="titleTwo">大数据信用信息服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>信用信息整理与清洗</h4>
                      <el-form-item label="服务客户数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.creditCleaningCustomerNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.creditCleaningCustomerNumber, oldDataBeforeChange.creditCleaningCustomerNumber)">（修改前：{{oldDataBeforeChange.creditCleaningCustomerNumber==null?0:oldDataBeforeChange.creditCleaningCustomerNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <h4>互联网金融信用服务</h4>
                      <el-form-item label="服务客户数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.creditAnalysisCustomerNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.creditAnalysisCustomerNumber, oldDataBeforeChange.creditAnalysisCustomerNumber)">（修改前：{{oldDataBeforeChange.creditAnalysisCustomerNumber==null?0:oldDataBeforeChange.creditAnalysisCustomerNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>信用信息挖掘与分析</h4>
                      <el-form-item label="服务客户数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.internetServiceCustomerNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.internetServiceCustomerNumber, oldDataBeforeChange.internetServiceCustomerNumber)">（修改前：{{oldDataBeforeChange.internetServiceCustomerNumber==null?0:oldDataBeforeChange.internetServiceCustomerNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedNine||situationForm.product?situationForm.product.includes('信用管理咨询'):''">
                  <h4 class="titleTwo">信用管理咨询</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>信用信息场景应用</h4>
                      <el-form-item label="服务客户数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.creditApplicationCustomerNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.creditApplicationCustomerNumber, oldDataBeforeChange.creditApplicationCustomerNumber)">（修改前：{{oldDataBeforeChange.creditApplicationCustomerNumber==null?0:oldDataBeforeChange.creditApplicationCustomerNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <h4>信用培训服务</h4>
                      <el-form-item label="培训场次">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.creditTrainingSession}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.creditTrainingSession, oldDataBeforeChange.creditTrainingSession)">（修改前：{{oldDataBeforeChange.creditTrainingSession==null?0:oldDataBeforeChange.creditTrainingSession}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="培训人次合计">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.creditTotalTrainingPerson}}</span> 人次
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.creditTotalTrainingPerson, oldDataBeforeChange.creditTotalTrainingPerson)">（修改前：{{oldDataBeforeChange.creditTotalTrainingPerson==null?0:oldDataBeforeChange.creditTotalTrainingPerson}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>信用预警</h4>
                      <el-form-item label="当年被预警监测企业数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.creditMonitoredWarningNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.creditMonitoredWarningNumber, oldDataBeforeChange.creditMonitoredWarningNumber)">（修改前：{{oldDataBeforeChange.creditMonitoredWarningNumber==null?0:oldDataBeforeChange.creditMonitoredWarningNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <el-form-item label="当年预警服务的客户数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.creditCustomerWarningNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.creditCustomerWarningNumber, oldDataBeforeChange.creditCustomerWarningNumber)">（修改前：{{oldDataBeforeChange.creditCustomerWarningNumber==null?0:oldDataBeforeChange.creditCustomerWarningNumber}}）</span>
                        </el-col>

                      </el-form-item>
                      <h4>信用信息安全管理</h4>
                      <el-form-item label="服务客户数">

                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                          <span>{{situationForm.creditManagementCustomerNumber}}</span> 家
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                          <span class="before-changes-item" v-if="compareNewOld(situationForm.creditManagementCustomerNumber, oldDataBeforeChange.creditManagementCustomerNumber)">（修改前：{{oldDataBeforeChange.creditManagementCustomerNumber==null?0:oldDataBeforeChange.creditManagementCustomerNumber}}）</span>
                        </el-col>

                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </template>

            </el-tab-pane>
          </el-tabs>
          <el-tabs class="nav" id="nav" v-model="activeName" @tab-click="navClick" v-else>
            <!-- 会员--基本情况 -->
            <el-tab-pane name="1">
              <span slot="label" class="content"><img src="@/assets/img/基本情况.png" alt="">基本情况</span>
              <h3>基本情况</h3>
              <el-divider></el-divider>
              <el-row class="itemCommon">
                <el-form-item label="公司名" class="itemOne" prop="companyName">
                  <el-input ref="companyName" v-model="situationForm.companyName"></el-input>
                </el-form-item>
                <el-form-item label="组织机构代码" class="itemOne" prop="organizationCode">
                  <el-input ref="organizationCode" v-model="situationForm.organizationCode"></el-input>
                </el-form-item>
              </el-row>
              <el-row class="itemCommon">

                <el-form-item prop="product" label="请勾选主要业务活动(或主要产品)">
                  <el-checkbox-group ref="product" v-model="situationForm.product" @change="productChange">
                    <p>基础信息服务</p>
                    <el-checkbox label="信用调查与服务" :checked="checkedOne" @change="oneChange">
                      信用调查与服务
                      <el-popover placement="top-start" width="200" trigger="hover" content="包含企业信用服务、个人信用服务">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="公共信用管理服务" :checked="checkedTwo" @change="twoChange">
                      公共信用管理服务
                      <el-popover placement="top-start" width="200" trigger="hover" content="包含社会信用管理服务、行业信用管理服务">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <p>增值信用服务</p>
                    <!-- <el-checkbox label="增值信用服务"></el-checkbox> -->
                    <el-checkbox label="信用评价" :checked="checkedThree" @change="threeChange">
                      信用评价
                      <el-popover placement="top-start" width="200" trigger="hover" content="包含工商企业信用评价服务、金融机构信用评价服务、结构融资评价、公共融资信用评价服务、主权信用评价服务">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="信用担保" :checked="checkedFour" @change="fourChange"></el-checkbox>
                    <el-checkbox label="保理" :checked="checkedFive" @change="fiveChange">
                      保理
                      <el-popover placement="top-start" width="200" trigger="hover" content="包含银行保理、商业保理">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="信用保险服务" :checked="checkedSix" @change="sixChange">
                      信用保险服务
                      <el-popover placement="top-start" width="200" trigger="hover" content="商业信用保险服务、出口信用保险服务">
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="商账管理服务" :checked="checkedSeven" @change="sevenChange"></el-checkbox>
                    <p>衍生信用服务</p>
                    <!-- <el-checkbox label="衍生信用服务"></el-checkbox> -->
                    <el-checkbox label="大数据信用信息服务" :checked="checkedEight" @change="eightChange">
                      大数据信用信息服务
                      <el-popover placement="top-start" width="200" trigger="hover" content=包含信用信息整理与清洗、信用信息挖掘与分析、互联网金融信用服务>
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                    <el-checkbox label="信用管理咨询" :checked="checkedNine" @change="nineChange">
                      信用管理咨询
                      <el-popover placement="top-start" width="200" trigger="hover" content=包含信用信息场景应用、信用预警、信用培训服务、信用信息安全管理>
                        <img slot="reference" src="@/assets/img/问号.png" alt="" class="wenhao">
                      </el-popover>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-row>
              <el-row class="itemCommon">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="法定代表人(单位负责人)：" prop="legalRepresentative" class="itemThree">
                    <el-input ref="legalRepresentative" v-model="situationForm.legalRepresentative">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="开业(成立)时间：" prop="openTime">
                    <el-date-picker ref="openTime" v-model="situationForm.openTime" type="date" placeholder="选择日期" @change="timeChange">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="itemCommon">
                <el-form-item label="单位经营地址" class="itemFive" prop="busAddress">
                  <el-row class="addContact" v-if="roleType==3&&!isEdit&&$route.name=='Management'">
                    <div @click="addBusAddressData"><i class="el-icon-plus"> 新 增</i></div>
                  </el-row>
                  <el-table ref="busAddress" :data="situationForm.busAddress" stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="80">
                    </el-table-column>
                    <el-table-column prop="address" label="具体地址">
                    </el-table-column>
                    <el-table-column label="操作" v-if="roleType==3&&!isEdit&&$route.name=='Management'">
                      <template slot-scope="scope">
                        <span class="downLoad edit" @click="editBusAddressData(scope.row,scope.$index)">修改</span>
                        <span class="downLoad" @click="deleteBusAddressData(scope.row,scope.$index)">删除</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-row>
              <el-row class="itemCommon">

                <el-form-item prop="legalPersonList" label="下一级法人单位情况：">
                  <el-row class="addContact" v-if="roleType==3&&!isEdit&&$route.name=='Management'">
                    <div @click="addLegalPerNext"><i class="el-icon-plus"> 添加</i></div>
                  </el-row>
                  <el-table :data="unitInfoArr" stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="80">
                      <template slot-scope="scope">
                        {{(nextUnitPageNumber - 1)*4 + scope.$index + 1 }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="organizationCode" label="组织机构代码">
                    </el-table-column>
                    <el-table-column prop="unitName" label="单位详细名称">
                    </el-table-column>
                    <el-table-column prop="legalRepresentative" label="详细地址">
                    </el-table-column>
                    <el-table-column prop="contactPhone" label="联系电话">
                    </el-table-column>
                    <el-table-column label="操作" v-if="roleType==3&&!isEdit&&$route.name=='Management'">
                      <template slot-scope="scope">
                        <span class="downLoad edit" @click="editLegalPerNext(scope.row,(nextUnitPageNumber - 1)*4 + scope.$index)">修改</span>
                        <span class="downLoad" @click="deleteLegalPerNext(scope.row,scope.$index)">删除</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination @current-change="nextUnitChange" :current-page.sync="nextUnitPageNumber" :page-size="nextUnitPageSize" layout="total, prev, pager, next" :total="nextUnitTotal">
                  </el-pagination>
                </el-form-item>
              </el-row>
              <el-row class="itemCommon" v-if="roleType==2&&$route.name=='Management'">
                <el-form-item label="企业控股情况">
                  <span v-if="situationForm.enterpriseHoldingType == 1">有限责任公司</span>
                  <span v-else-if="situationForm.enterpriseHoldingType == 2">个体户</span>
                  <span v-else-if="situationForm.enterpriseHoldingType == 3">办事处或非盈利公司</span>
                  <span v-else-if="situationForm.enterpriseHoldingType == 4">上市公司</span>
                  <span v-else-if="situationForm.enterpriseHoldingType == 5">其他</span>
                  <span v-else-if="situationForm.enterpriseHoldingType == 6">国营企业</span>
                  <span v-else-if="situationForm.enterpriseHoldingType == 7">非盈利企业</span>
                  <span v-else-if="situationForm.enterpriseHoldingType == 8">合伙企业</span>
                </el-form-item>
              </el-row>
            </el-tab-pane>
            <!-- 会员--从业人员情况 -->
            <el-tab-pane name="2">
              <div slot="label" class="content"><img src="@/assets/img/从业人员.png" alt="">从业人员情况</div>
              <h3>从业情况</h3>
              <el-divider></el-divider>
              <el-row class="itemCommon ">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="年末从业人员数" prop="employeesYearEndNumber">
                    <el-input @keyup.native="onlyIntVal($event,'employeesYearEndNumber')" v-model="situationForm.employeesYearEndNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row class="congye">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColone">
                  <h4>按学历分:
                    <span class="sumNo-match" v-show='sumNoMatch1'>人数总和与年末从业人数不符</span>
                  </h4>
                  <el-form-item label="研究生以上及学历" prop="masterDegreeOrAboveNumber">
                    <el-input @keyup.native="onlyIntVal($event,'masterDegreeOrAboveNumber')" v-model="situationForm.masterDegreeOrAboveNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                  <el-form-item label="大学本科学历" prop="bachelorDegreeNumber">
                    <el-input @keyup.native="onlyIntVal($event,'bachelorDegreeNumber')" v-model="situationForm.bachelorDegreeNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                  <el-form-item label="大专学历" prop="collegeDegreeNumber">
                    <el-input @keyup.native="onlyIntVal($event,'collegeDegreeNumber')" v-model="situationForm.collegeDegreeNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                  <el-form-item label="高中及以下学历" prop="highSchoolDegreeOrBelowNumber">
                    <el-input @keyup.native="onlyIntVal($event,'highSchoolDegreeOrBelowNumber')" v-model="situationForm.highSchoolDegreeOrBelowNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                </el-col>
                <span class="line"></span>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                  <h4>按从业年限分:
                    <span class="sumNo-match" v-show='sumNoMatch2'>人数总和与年末从业人数不符</span>
                  </h4>
                  <el-form-item label="五年以上" prop="fiveYearAndAboveNumber">
                    <el-input @keyup.native="onlyIntVal($event,'fiveYearAndAboveNumber')" v-model="situationForm.fiveYearAndAboveNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                  <el-form-item label="三年以上五年以下" prop="threeYearsFiveNumber">
                    <el-input @keyup.native="onlyIntVal($event,'threeYearsFiveNumber')" v-model="situationForm.threeYearsFiveNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                  <el-form-item label="一年以上三年以下" prop="oneYearThreeNumber">
                    <el-input @keyup.native="onlyIntVal($event,'oneYearThreeNumber')" v-model="situationForm.oneYearThreeNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                  <el-form-item label="一年以下" prop="followingYearNumber">
                    <el-input @keyup.native="onlyIntVal($event,'followingYearNumber')" v-model="situationForm.followingYearNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row class="congye">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColone">
                  <h4>拥有专业技术职称人数,其中:</h4>
                  <el-form-item label="高级技术职称" prop="seniorTechnicalNumber">
                    <el-input @keyup.native="onlyIntVal($event,'seniorTechnicalNumber')" v-model="situationForm.seniorTechnicalNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                  <el-form-item label="中级技术职称" prop="intermediateTechnicalNumber">
                    <el-input @keyup.native="onlyIntVal($event,'intermediateTechnicalNumber')" v-model="situationForm.intermediateTechnicalNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                  <el-form-item label="初级及以下技术职称" prop="juniorBelowTechnicalNumber">
                    <el-input @keyup.native="onlyIntVal($event,'juniorBelowTechnicalNumber')" v-model="situationForm.juniorBelowTechnicalNumber" @change="judgeSumMatch"></el-input>人
                  </el-form-item>
                </el-col>
                <span class="line"></span>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                  <h4>持有国内职业证书人数,其中:</h4>
                  <el-form-item label="注册会计师" prop="certifiedAccountantNumber">
                    <el-input @keyup.native="onlyIntVal($event,'certifiedAccountantNumber')" v-model="situationForm.certifiedAccountantNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="具证券从业资格人员" prop="personnelSecuritiesNumber">
                    <el-input @keyup.native="onlyIntVal($event,'personnelSecuritiesNumber')" v-model="situationForm.personnelSecuritiesNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="具律师从业资格人员" prop="personsQualifiedLawyersNumber">
                    <el-input @keyup.native="onlyIntVal($event,'personsQualifiedLawyersNumber')" v-model="situationForm.personsQualifiedLawyersNumber"></el-input>人
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row class="congye">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColone">
                  <h4>持有国外证书人数,其中:</h4>
                  <el-form-item label="特许金融分析师(CFA)" prop="charteredFinancialAnalystNumber">
                    <el-input @keyup.native="onlyIntVal($event,'charteredFinancialAnalystNumber')" v-model="situationForm.charteredFinancialAnalystNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="英国特许公认会计师(ACCA)" prop="charteredCertifiedAccountantsNumber">
                    <el-input @keyup.native="onlyIntVal($event,'charteredCertifiedAccountantsNumber')" v-model="situationForm.charteredCertifiedAccountantsNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="美国注册会计师(AICPA)" prop="americanCertifiedAccountantNumber">
                    <el-input @keyup.native="onlyIntVal($event,'americanCertifiedAccountantNumber')" v-model="situationForm.americanCertifiedAccountantNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="国际注册信用分析师(CICA)" prop="internationalRegisteredCreditAnalystNumber">
                    <el-input @keyup.native="onlyIntVal($event,'internationalRegisteredCreditAnalystNumber')" v-model="situationForm.internationalRegisteredCreditAnalystNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="国际注册信用师(ICCA)" prop="internationalRegisteredCreditOfficerNumber">
                    <el-input @keyup.native="onlyIntVal($event,'internationalRegisteredCreditOfficerNumber')" v-model="situationForm.internationalRegisteredCreditOfficerNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="国际信用管理师(ICM)" prop="internationalCreditManagerIcmNumber">
                    <el-input @keyup.native="onlyIntVal($event,'internationalCreditManagerIcmNumber')" v-model="situationForm.internationalCreditManagerIcmNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="国际信用管理员(ICA)" prop="internationalCreditManagerIcaNumber">
                    <el-input @keyup.native="onlyIntVal($event,'internationalCreditManagerIcaNumber')" v-model="situationForm.internationalCreditManagerIcaNumber"></el-input>人
                  </el-form-item>

                </el-col>
                <span class="line"></span>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                  <h4>持有国内培训证书人数,其中:</h4>
                  <el-form-item label="信用管理师" prop="creditManagerNumber">
                    <el-input @keyup.native="onlyIntVal($event,'creditManagerNumber')" v-model="situationForm.creditManagerNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="获信用管理岗位证书人员" prop="staffCreditManagementCertificateNumber">
                    <el-input @keyup.native="onlyIntVal($event,'staffCreditManagementCertificateNumber')" v-model="situationForm.staffCreditManagementCertificateNumber"></el-input>人
                  </el-form-item>
                  <el-form-item label="注册咨询师" prop="registeredConsultantNumber">
                    <el-input @keyup.native="onlyIntVal($event,'registeredConsultantNumber')" v-model="situationForm.registeredConsultantNumber"></el-input>人
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <!-- 会员--财务状况 -->
            <el-tab-pane name="3">
              <span slot="label" class="content"><img src="@/assets/img/财务.png" alt="">财务状况</span>
              <h3>财务状况 </h3>
              <el-divider></el-divider>
              <el-row class="itemCommon ">
                <h4 style="margin-bottom:20px;">资产负债:</h4>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="资产总计" prop="totalAssetsAmount">
                    <el-input type="number" v-model="situationForm.totalAssetsAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="负债合计" prop="totalLiabilitiesAmount">
                    <el-input type="number" v-model="situationForm.totalLiabilitiesAmount"></el-input>千元
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="税前利润" prop="preTaxProfitsAmount">
                    <el-input type="number" v-model="situationForm.preTaxProfitsAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="营业收入" prop="operatingIncome">
                    <el-input type="number" v-model="situationForm.operatingIncome"></el-input>千元
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="itemCommon">
                <h4 style="margin-bottom:20px;">损益及分配:</h4>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-if="situationForm.product">
                  <el-form-item label="信用调查与服务业务" prop="creditInvestigationServiceAmount" v-if="checkedOne||situationForm.product?situationForm.product.includes('信用调查与服务'):''">
                    <el-input type="number" ref="creditInvestigationServiceAmount" v-model=" situationForm.creditInvestigationServiceAmount"> </el-input>千元
                  </el-form-item>
                  <el-form-item label="公共信用管理服务业务" prop="publicCreditManagementServiceAmount" v-if="checkedTwo||situationForm.product?situationForm.product.includes('公共信用管理服务'):''">
                    <el-input type="number" ref="publicCreditManagementServiceAmount" v-model="situationForm.publicCreditManagementServiceAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="信用评价业务" prop="creditRatingServiceAmount" v-if="checkedThree||situationForm.product?situationForm.product.includes('信用评价'):''">
                    <el-input type="number" ref="creditRatingServiceAmount" v-model="situationForm.creditRatingServiceAmount"> </el-input>千元
                  </el-form-item>
                  <el-form-item label="信用担保业务" prop="creditGuaranteeBusinessAmount" v-if="checkedFour||situationForm.product?situationForm.product.includes('信用担保'):''">
                    <el-input type="number" ref="creditGuaranteeBusinessAmount" v-model="situationForm.creditGuaranteeBusinessAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="保理业务" prop="commercialFactoringAmount" v-if="checkedFive||situationForm.product?situationForm.product.includes('保理'):''">
                    <el-input type="number" ref="commercialFactoringAmount" v-model="situationForm.commercialFactoringAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="信用保险服务业务" prop="creditInsuranceServiceAmount" v-if="checkedSix||situationForm.product?situationForm.product.includes('信用保险服务'):''">
                    <el-input type="number" ref="creditInsuranceServiceAmount" v-model="situationForm.creditInsuranceServiceAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="商账管理服务业务" prop="businessAccountManagementServiceAmount" v-if="checkedSeven||situationForm.product?situationForm.product.includes('商账管理服务'):''">
                    <el-input type="number" ref="businessAccountManagementServiceAmount" v-model="situationForm.businessAccountManagementServiceAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="大数据信用信息服务业务" prop="creditServiceAmount" v-if="checkedEight||situationForm.product?situationForm.product.includes('大数据信用信息服务'):''">
                    <el-input type="number" ref="creditServiceAmount" v-model="situationForm.creditServiceAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="信用管理咨询业务" prop="creditManagementServiceAmount" v-if="checkedNine||situationForm.product?situationForm.product.includes('信用管理咨询'):''">
                    <el-input type="number" ref="creditManagementServiceAmount" v-model="situationForm.creditManagementServiceAmount"></el-input>千元
                  </el-form-item>
                  <el-form-item label="其他业务收入" prop="otherBusinessAmount">
                    <el-input type="number" v-model="situationForm.otherBusinessAmount"></el-input>千元
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="itemCommon">
                <el-form-item label="其他业务内容描述说明" prop="otherBusinessContentDescription">
                  <el-input type="textarea" v-model="situationForm.otherBusinessContentDescription"></el-input>
                </el-form-item>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item label="净利润" prop="netProfitAmount">
                    <el-input type="number" v-model="situationForm.netProfitAmount"></el-input>千元
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <!-- 会员--业务状况 -->
            <el-tab-pane name="4">
              <span slot="label" class="content fare"><img src="@/assets/img/业务.png" alt="">业务状况</span>
              <h3>业务状况 </h3>
              <el-divider></el-divider>
              <!-- 有数据 -->
              <template v-if="checkedOne||checkedTwo||(situationForm.product?situationForm.product.includes('信用调查与服务'):'')||(situationForm.product?situationForm.product.includes('公共信用管理服务'):'')">
                <h3>基础信用服务</h3>
                <el-divider></el-divider>
                <template v-if=" checkedOne||situationForm.product?situationForm.product.includes('信用调查与服务'):''">
                  <h4 class="titleTwo">信用调查与服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColone">
                      <h4>企业信用服务</h4>
                      <el-form-item label="信用报告出具数" prop="companyCreditReportNumber">
                        <el-input ref="companyCreditReportNumber" @keyup.native="onlyIntVal($event,'companyCreditReportNumber')" v-model="situationForm.companyCreditReportNumber"></el-input>份
                      </el-form-item>
                      <el-form-item label="其他征信服务产品提供次数" prop="companyOtherCreditProductNumber">
                        <el-input ref="companyOtherCreditProductNumber" @keyup.native="onlyIntVal($event,'companyOtherCreditProductNumber')" v-model="situationForm.companyOtherCreditProductNumber"></el-input>份
                      </el-form-item>
                      <el-form-item label="客户数量" prop="companyCustomerNumber">
                        <el-input ref="companyCustomerNumber" @keyup.native="onlyIntVal($event,'companyCustomerNumber')" v-model="situationForm.companyCustomerNumber"></el-input>家
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>个人信用服务</h4>
                      <el-form-item label="信用报告出具数" prop="personalCreditReportNumber">
                        <el-input ref="personalCreditReportNumber" @keyup.native="onlyIntVal($event,'personalCreditReportNumber')" v-model="situationForm.personalCreditReportNumber"></el-input>份
                      </el-form-item>
                      <el-form-item label="客户数量" prop="personalCustomerNumber">
                        <el-input ref="personalCustomerNumber" @keyup.native="onlyIntVal($event,'personalCustomerNumber')" v-model="situationForm.personalCustomerNumber"></el-input>家
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedTwo||situationForm.product?situationForm.product.includes('公共信用管理服务'):''">
                  <h4 class="titleTwo">公共信用管理服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>社会信用管理服务</h4>
                      <el-form-item label="服务政府项目数" prop="socialGovernmentProjectNumber">
                        <el-input ref="socialGovernmentProjectNumber" @keyup.native="onlyIntVal($event,'socialGovernmentProjectNumber')" v-model="situationForm.socialGovernmentProjectNumber"></el-input>次
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>行业信用管理服务</h4>
                      <el-form-item label="服务行业协会项目数" prop="industryServiceIndustryNumber">
                        <el-input ref="industryServiceIndustryNumber" @keyup.native="onlyIntVal($event,'industryServiceIndustryNumber')" v-model="situationForm.industryServiceIndustryNumber"></el-input>次
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </template>
              <template v-else-if="checkedThree||checkedFour||checkedFive||checkedSix||checkedSeven||(situationForm.product?situationForm.product.includes('信用评价'):'')||(situationForm.product?situationForm.product.includes('信用担保'):'')||(situationForm.product?situationForm.product.includes('保理'):'')||(situationForm.product?situationForm.product.includes('信用保险服务'):'')||(situationForm.product?situationForm.product.includes('商账管理服务'):'')">
                <h3>增值信用服务</h3>
                <el-divider></el-divider>
                <template v-if="checkedThree||situationForm.product?situationForm.product.includes('信用评价'):''">
                  <h4 class="titleTwo">信用评价</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>工商企业信用评价服务</h4>
                      <el-form-item label="评价数量" prop="industryRatingNumber">
                        <el-input ref="industryRatingNumber" @keyup.native="onlyIntVal($event,'industryRatingNumber')" v-model="situationForm.industryRatingNumber"></el-input>
                      </el-form-item>
                      <h4>结构融资评价</h4>
                      <el-form-item label="评价数量" prop="structuredRatingNumber">
                        <el-input ref="structuredRatingNumber" @keyup.native="onlyIntVal($event,'structuredRatingNumber')" v-model="situationForm.structuredRatingNumber"></el-input>
                      </el-form-item>
                      <h4>主权信用评价服务</h4>
                      <el-form-item label="评价数量" prop="sovereignRatingNumber">
                        <el-input ref="sovereignRatingNumber" @keyup.native="onlyIntVal($event,'sovereignRatingNumber')" v-model="situationForm.sovereignRatingNumber"></el-input>
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>金融机构信用评价服务</h4>
                      <el-form-item label="评价数量" prop="financialRatingNumber">
                        <el-input ref="financialRatingNumber" @keyup.native="onlyIntVal($event,'financialRatingNumber')" v-model="situationForm.financialRatingNumber"></el-input>
                      </el-form-item>
                      <h4>公共融资信用评价服务</h4>
                      <el-form-item label="评价数量" prop="publicRatingNumber">
                        <el-input ref="publicRatingNumber" @keyup.native="onlyIntVal($event,'publicRatingNumber')" v-model="situationForm.publicRatingNumber"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedFour||situationForm.product?situationForm.product.includes('信用担保'):''">
                  <h4 class="titleTwo">信用担保</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="担保数量" prop="guaranteeNumber">
                        <el-input ref="guaranteeNumber" @keyup.native="onlyIntVal($event,'guaranteeNumber')" v-model="situationForm.guaranteeNumber"></el-input>笔
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <el-form-item label="担保金额合计" prop="totalGuaranteeAmount">
                        <el-input ref="totalGuaranteeAmount" @keyup.native="onlyIntVal($event,'totalGuaranteeAmount')" v-model="situationForm.totalGuaranteeAmount"></el-input>千元
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedFive||situationForm.product?situationForm.product.includes('保理'):''">
                  <h4 class="titleTwo">保理</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>银行保理</h4>
                      <el-form-item label="保理业务发生笔数" prop="bankFactoringNumber">
                        <el-input ref="bankFactoringNumber" @keyup.native="onlyIntVal($event,'bankFactoringNumber')" v-model="situationForm.bankFactoringNumber"></el-input>笔
                      </el-form-item>
                      <el-form-item label="保理业务发生额" prop="bankFactoringIncurredAmount">
                        <el-input ref="bankFactoringIncurredAmount" @keyup.native="onlyIntVal($event,'bankFactoringIncurredAmount')" v-model="situationForm.bankFactoringIncurredAmount"></el-input>千元
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>商业保理</h4>
                      <el-form-item label="保理业务发生笔数" prop="commercialFactoringNumber">
                        <el-input ref="commercialFactoringNumber" @keyup.native="onlyIntVal($event,'commercialFactoringNumber')" v-model="situationForm.commercialFactoringNumber"></el-input>笔
                      </el-form-item>
                      <el-form-item label="保理业务发生额" prop="commercialFactoringIncurredAmount">
                        <el-input ref="commercialFactoringIncurredAmount" @keyup.native="onlyIntVal($event,'commercialFactoringIncurredAmount')" v-model="situationForm.commercialFactoringIncurredAmount"></el-input>千元
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedSix||situationForm.product?situationForm.product.includes('信用保险服务'):''">
                  <h4 class="titleTwo">信用保险服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>商业信用保险服务</h4>
                      <el-form-item label="保单数" prop="commercialPoliciesNumber">
                        <el-input ref="commercialPoliciesNumber" @keyup.native="onlyIntVal($event,'commercialPoliciesNumber')" v-model="situationForm.commercialPoliciesNumber"></el-input>笔
                      </el-form-item>
                      <el-form-item label="承保金额合计" prop="commercialTotalInsuredAmount">
                        <el-input ref="commercialTotalInsuredAmount" @keyup.native="onlyIntVal($event,'commercialTotalInsuredAmount')" v-model="situationForm.commercialTotalInsuredAmount"></el-input>千元
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>出口信用保险服务</h4>
                      <el-form-item label="保单数" prop="exportPoliciesNumber">
                        <el-input ref="exportPoliciesNumber" @keyup.native="onlyIntVal($event,'exportPoliciesNumber')" v-model="situationForm.exportPoliciesNumber"></el-input>笔
                      </el-form-item>
                      <el-form-item label="承保金额合计" prop="exportTotalInsuredAmount">
                        <el-input ref="exportTotalInsuredAmount" @keyup.native="onlyIntVal($event,'exportTotalInsuredAmount')" v-model="situationForm.exportTotalInsuredAmount"></el-input>千元
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedSeven||situationForm.product?situationForm.product.includes('商账管理服务'):''">
                  <h4 class="titleTwo">商账管理服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="应收账委托金额合计" prop="totalEntrustmentAmount">
                        <el-input ref="totalEntrustmentAmount" @keyup.native="onlyIntVal($event,'totalEntrustmentAmount')" v-model="situationForm.totalEntrustmentAmount"></el-input>千元
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <el-form-item label="应收账款回收金额合计" prop="totalReceivablesAmount">
                        <el-input ref="totalReceivablesAmount" @keyup.native="onlyIntVal($event,'totalReceivablesAmount')" v-model="situationForm.totalReceivablesAmount"></el-input>千元
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>

              </template>
              <template v-else-if="checkedEight||checkedNine||(situationForm.product?situationForm.product.includes('大数据信用信息服务'):'')||(situationForm.product?situationForm.product.includes('信用管理咨询'):'')">
                <h3>衍生信用服务</h3>
                <el-divider></el-divider>
                <template v-if="checkedEight||situationForm.product?situationForm.product.includes('大数据信用信息服务'):''">
                  <h4 class="titleTwo">大数据信用信息服务</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>信用信息整理与清洗</h4>
                      <el-form-item label="服务客户数" prop="creditCleaningCustomerNumber">
                        <el-input ref="creditCleaningCustomerNumber" @keyup.native="onlyIntVal($event,'creditCleaningCustomerNumber')" v-model="situationForm.creditCleaningCustomerNumber"></el-input>家
                      </el-form-item>
                      <h4>互联网金融信用服务</h4>
                      <el-form-item label="服务客户数" prop="creditAnalysisCustomerNumber">
                        <el-input ref="creditAnalysisCustomerNumber" @keyup.native="onlyIntVal($event,'creditAnalysisCustomerNumber')" v-model="situationForm.creditAnalysisCustomerNumber"></el-input>家
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>信用信息挖掘与分析</h4>
                      <el-form-item label="服务客户数" prop="internetServiceCustomerNumber">
                        <el-input ref="internetServiceCustomerNumber" @keyup.native="onlyIntVal($event,'internetServiceCustomerNumber')" v-model="situationForm.internetServiceCustomerNumber"></el-input>家
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="checkedNine||situationForm.product?situationForm.product.includes('信用管理咨询'):''">
                  <h4 class="titleTwo">信用管理咨询</h4>
                  <el-row class="itemCommon congye">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <h4>信用信息场景应用</h4>
                      <el-form-item label="服务客户数" prop="creditApplicationCustomerNumber">
                        <el-input ref="creditApplicationCustomerNumber" @keyup.native="onlyIntVal($event,'creditApplicationCustomerNumber')" v-model="situationForm.creditApplicationCustomerNumber"></el-input>家
                      </el-form-item>
                      <h4>信用培训服务</h4>
                      <el-form-item label="培训场次" prop="creditTrainingSession">
                        <el-input ref="creditTrainingSession" @keyup.native="onlyIntVal($event,'creditTrainingSession')" v-model="situationForm.creditTrainingSession"></el-input>家
                      </el-form-item>
                      <el-form-item label="培训人次合计" prop="creditTotalTrainingPerson">
                        <el-input ref="creditTotalTrainingPerson" @keyup.native="onlyIntVal($event,'creditTotalTrainingPerson')" v-model="situationForm.creditTotalTrainingPerson"></el-input>人次
                      </el-form-item>
                    </el-col>
                    <span class="line"></span>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="congyeColtwo">
                      <h4>信用预警</h4>
                      <el-form-item label="当年被预警监测企业数" prop="creditMonitoredWarningNumber">
                        <el-input ref="creditMonitoredWarningNumber" @keyup.native="onlyIntVal($event,'creditMonitoredWarningNumber')" v-model="situationForm.creditMonitoredWarningNumber"></el-input>家
                      </el-form-item>
                      <el-form-item label="当年预警服务的客户数" prop="creditCustomerWarningNumber">
                        <el-input ref="creditCustomerWarningNumber" @keyup.native="onlyIntVal($event,'creditCustomerWarningNumber')" v-model="situationForm.creditCustomerWarningNumber"></el-input>家
                      </el-form-item>
                      <h4>信用信息安全管理</h4>
                      <el-form-item label="服务客户数" prop="creditManagementCustomerNumber">
                        <el-input ref="creditManagementCustomerNumber" @keyup.native="onlyIntVal($event,'creditManagementCustomerNumber')" v-model="situationForm.creditManagementCustomerNumber"></el-input>家
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </template>
              <!-- 没数据 -->
              <template v-else>
                <div class="quesstion-nocompulete-tag">
                  <i class="el-icon-warning"></i>
                  请先前往调查表的“基本情况”模块中勾选主要业务活动
                </div>
              </template>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <!-- <questionaire-detail :ref="refData[index]"></questionaire-detail> -->
      </el-tab-pane>
    </el-tabs>
    <!-- 下一级法人单位情况对话框--会员 -->
    <el-dialog :title="legalPerNextFormStatus==1?'添加下一级法人单位情况':'修改下一级法人单位情况'" :visible.sync="legalPerNextVisible" width="40%" custom-class="legalPerNextVisible">
      <el-form :model="legalPerNextForm" :rules="legalPerNextFormRules" ref="legalPerNextForm" label-width="120px" class="demo-legalPerNextForm">
        <el-form-item label="组织机构代码" prop="organizationCode">
          <el-input v-model="legalPerNextForm.organizationCode" @change="inputOneChange"></el-input>
        </el-form-item>
        <el-form-item label="单位详细名称" prop="unitName">
          <el-input v-model="legalPerNextForm.unitName" @change="inputOneChange"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="legalRepresentative">
          <el-input v-model="legalPerNextForm.legalRepresentative" @change="inputOneChange"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="legalPerNextForm.contactPhone" @change="inputOneChange"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="legalPerNextSubmit">{{legalPerNextFormStatus==1?'添加':'修改'}}</span>
        <span class="button" @click="legalPerNextVisible = false">取 消</span>
      </span>
    </el-dialog>
    <!-- 单位经营地对话框 -->
    <el-dialog :title="busStatus==1?'添加单位经营地及区划地址':'修改单位经营地及区划地址'" :visible.sync="busVisible" width="40%" custom-class="busVisible">
      <el-form :model="busForm" :rules="busFormRules" ref="busForm" label-width="180px" class="demo-ruleForm" :disabled="isDisabled">
        <el-form-item label="单位经营地及区划地址" prop="street">
          <v-distpicker :province="busForm.province" :city="busForm.city" :area="busForm.area" @selected="selectPickerOne"></v-distpicker>
          <el-input class="address" placeholder="详细地址" v-model="busForm.street" @change="inputOneChange"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="addBusAddress">{{busStatus==1?'添加':'修改'}}</span>
        <span class="button" @click="busVisible = false">取 消</span>
      </span>
    </el-dialog>
    <!-- 审批 -->
    <el-dialog title="审批拒绝" :visible.sync="applyVisible" width="25%" custom-class="addInfoVisible" @close="closeApplyDialog">
      <el-row>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">拒绝原因:</el-col>
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
          <el-input type="textarea" v-model="reasonPrams.comment" placeholder="请填写拒绝原因"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="isSuccess(4)">确 定</span>
        <span class="button" type="primary" @click="applyVisible=false">取 消</span>
      </span>
    </el-dialog>
    <!-- 已经通过了的调查表，当会员点击【编辑】时就弹出弹框 -->
    <el-dialog title="提示" :visible.sync="alreadyPassVisible" width="30%">
      <span>是否确认编辑，确认编辑后之前填写的调查表的内容将会被删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="alreadyPassSure">确 定</el-button>
        <el-button @click="alreadyPassVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 任务退回对话框 -->
    <BackDialog ref="backDialog" />
    <!-- 修改调查表原因对话框 -->
    <ReasonDialog ref="reasonDialog" />
  </div>
</template>
<script>
import BackDialog from '@/views/Home/common/BackDialog.vue'
import ReasonDialog from '@/components/ReasonDialog.vue'
import Loading from '@/components/Loading.vue'
import { questionnaireInfo, applyRecord, taskManagement, addOrUpdateQuestionnaireInfo, importQuesInfo, findQuestionnaireInfoBack } from '@/api/index'
export default {
  props: ['yearData', 'quesNaireData'],

  data() {
    return {
      name: 'Questionnaire',
      isLoading: false,
      adminPower: '',
      singleYear: [],
      headerObj: { token: window.sessionStorage.getItem('token') },
      fileList: [],
      files: null,
      fileName: '',
      userId: sessionStorage.getItem('userId'),
      publicPath: process.env.BASE_URL,  // 调查表模板路径
      roleType: sessionStorage.getItem('roleType'),
      quesYear: '',
      yearValue: '',
      isEdit: false,
      isSave: true,
      isSubmit: true,
      isSaveOrSubmit: null,//保存还是保存并提交 save保存submit保存并提交
      isDisabled: false,  // 是否禁止表格填写
      isButton: false,  // 是否禁止按钮点击
      activeName: '1',
      searchBarFixed: false,
      quesParams: {
        createUserId: '',
        year: '',
      },
      // 复选框是否选中
      checkedOne: false,
      checkedTwo: false,
      checkedThree: false,
      checkedFour: false,
      checkedFive: false,
      checkedSix: false,
      checkedSeven: false,
      checkedEight: false,
      checkedNine: false,
      // 管理员查看--复选框是否选中
      checkedOneShow: false,
      checkedTwoShow: false,
      checkedThreeShow: false,
      checkedFourShow: false,
      checkedFiveShow: false,
      checkedSixShow: false,
      checkedSevenShow: false,
      checkedEightShow: false,
      checkedNineShow: false,
      // 基础信息
      situationForm: {
        companyName: JSON.parse(sessionStorage.getItem('userInfo')).memberUnitName,
        //基础信息
        ramark: '',
        year: '',
        id: "",
        // operationType: '', //1添加 2修改
        saveType: "",  //1保存 2提交
        organizationCode: "",
        address: '',
        businessType: "",  // 业务活动类型
        businessAddress: "",
        legalRepresentative: '',
        openTime: '',
        // distanceCode: '',
        // mobilePhone: '',
        // postalCode: '',
        // website: '',
        // fixedTelephone: '',
        // faxNumber: '',
        // email: '',
        enterpriseHoldingType: '',
        // 从业人员情况
        employeesYearEndNumber: '',
        lastEmployeesYearEndNumber: '',
        masterDegreeOrAboveNumber: '',
        lastMasterDegreeOrAboveNumber: '',
        bachelorDegreeNumber: '',
        lastBachelorDegreeNumber: '',
        collegeDegreeNumber: '',
        lastCollegeDegreeNumber: '',
        highSchoolDegreeOrBelowNumber: '',
        lastHighSchoolDegreeOrBelowNumber: '',
        fiveYearAndAboveNumber: 0,
        lastFiveYearAndAboveNumber: '',
        threeYearsFiveNumber: '',
        lastThreeYearsFiveNumber: '',
        oneYearThreeNumber: '',
        lastOneYearThreeNumber: '',
        followingYearNumber: '',
        lastFollowingYearNumber: '',
        seniorTechnicalNumber: '',
        lastSeniorTechnicalNumber: '',
        intermediateTechnicalNumber: '',
        lastIntermediateTechnicalNumber: '',
        juniorBelowTechnicalNumber: '',
        lastJuniorBelowTechnicalNumber: '',
        certifiedAccountantNumber: '',
        lastCertifiedAccountantNumber: '',
        personnelSecuritiesNumber: '',
        lastPersonnelSecuritiesNumber: '',
        personsQualifiedLawyersNumber: '',
        lastPersonsQualifiedLawyersNumber: '',
        charteredFinancialAnalystNumber: '',
        lastCharteredFinancialAnalystNumber: '',
        charteredCertifiedAccountantsNumber: '',
        lastCharteredCertifiedAccountantsNumber: '',
        americanCertifiedAccountantNumber: '',
        lastAmericanCertifiedAccountantNumber: '',
        internationalRegisteredCreditAnalystNumber: '',
        lastInternationalRegisteredCreditAnalystNumber: '',
        internationalRegisteredCreditOfficerNumber: '',
        lastInternationalRegisteredCreditOfficerNumber: '',
        internationalCreditManagerIcmNumber: '',
        lastInternationalCreditManagerIcmNumber: '',
        internationalCreditManagerIcaNumber: '',
        lastInternationalCreditManagerIcaNumber: '',
        creditManagerNumber: '',
        lastCreditManagerNumber: '',
        staffCreditManagementCertificateNumber: '',
        lastStaffCreditManagementCertificateNumber: '',
        registeredConsultantNumber: '',
        lastRegisteredConsultantNumber: '',
        //财务状况
        totalAssetsAmount: "",
        totalLiabilitiesAmount: "",
        preTaxProfitsAmount: "",
        operatingIncome: "",
        lastTotalAssetsAmount: "",
        lastTotalLiabilitiesAmount: "",
        lastPreTaxProfitsAmount: "",
        lastOperatingIncome: "",
        basicInformationServicesBusinessAmount: "", //基础信息
        creditInvestigationServiceAmount: "0",
        publicCreditManagementServiceAmount: "",
        vatCreditServiceAmount: "",
        creditRatingServiceAmount: "",
        creditGuaranteeBusinessAmount: "",
        commercialFactoringAmount: "",
        creditInsuranceServiceAmount: "",
        businessAccountManagementServiceAmount: "",
        derivativeCreditServiceAmount: "",
        creditServiceAmount: '',
        creditManagementServiceAmount: "",
        operatingProfitAmount: "",
        otherBusinessContentDescription: '',
        netProfitAmount: "",
        lastBasicInformationServicesBusinessAmount: '',//上年基础信息
        lastCreditInvestigationServiceAmount: "",
        lastPublicCreditManagementServiceAmount: "",
        lastVatCreditServiceAmount: "",
        lastCreditRatingServiceAmount: "",
        lastCreditGuaranteeBusinessAmount: "",
        lastCommercialFactoringAmount: "",
        lastCreditInsuranceServiceAmount: "",
        lastBusinessAccountManagementServiceAmount: "",
        lastDerivativeCreditServiceAmount: "",
        lastCreditServiceAmount: "",
        lastCreditManagementServiceAmount: "",
        lastOtherBusinessAmount: "",
        lastOtherBusinessContentDescription: "",
        lastNetProfitAmount: "",
        // 业务情况
        companyCreditReportNumber: "",
        companyOtherCreditProductNumber: "",
        companyCustomerNumber: "",
        personalCreditReportNumber: "",
        personalCustomerNumber: "",
        socialGovernmentProjectNumber: "",
        industryServiceIndustryNumber: "",
        industryRatingNumber: "",
        financialRatingNumber: "",
        structuredRatingNumber: "",
        publicRatingNumber: "",
        sovereignRatingNumber: "",
        guaranteeNumber: "",
        totalGuaranteeAmount: "",
        bankFactoringNumber: "",
        bankFactoringIncurredAmount: "",
        commercialFactoringNumber: "",
        commercialFactoringIncurredAmount: "",
        commercialPoliciesNumber: "",
        commercialTotalInsuredAmount: "",
        exportPoliciesNumber: "",
        exportTotalInsuredAmount: "",
        totalEntrustmentAmount: "",
        totalReceivablesAmount: "",
        creditCleaningCustomerNumber: "",
        creditAnalysisCustomerNumber: "",
        internetServiceCustomerNumber: "",
        creditApplicationCustomerNumber: "",
        creditMonitoredWarningNumber: "",
        creditCustomerWarningNumber: "",
        creditTrainingSession: "",
        creditTotalTrainingPerson: "",
        creditManagementCustomerNumber: "",

        //自定义参数
        product: [],
        busAddress: [],
        comAddress: {
          province: '',
          city: '',
          area: '',
          street: ''
        },
      },
      situationFormRules: {
        // 基本
        companyName: [{ required: true, message: '请输入公司名', trigger: 'blur' }],
        // organizationCode: [{ required: true, message: '请输入组织机构代码', trigger: 'blur' }],
        product: [{ required: true, message: '请勾选主要业务活动', trigger: 'blur' }],
        busAddress: [{ required: true, message: '请输入单位经营地及区划地址', trigger: 'blur' }],
        legalRepresentative: [{ required: true, message: '请输入法定代表人(单位负责人)', trigger: 'blur' }],
        openTime: [{ required: true, message: '请输入开业(成立)时间', trigger: 'blur' }],
        // 财务
        creditInvestigationServiceAmount: [{ required: true, message: '请输入信用调查与服务业务', trigger: 'blur' }],
        publicCreditManagementServiceAmount: [{ required: true, message: '请输入公共信用管理服务业务', trigger: 'blur' }],
        creditRatingServiceAmount: [{ required: true, message: '请输入信用评价业务', trigger: 'blur' }],
        creditGuaranteeBusinessAmount: [{ required: true, message: '请输入信用担保业务', trigger: 'blur' }],
        commercialFactoringAmount: [{ required: true, message: '请输入保理业务', trigger: 'blur' }],
        creditInsuranceServiceAmount: [{ required: true, message: '请输入信用保险服务业务', trigger: 'blur' }],
        businessAccountManagementServiceAmount: [{ required: true, message: '请输入商账管理服务业务', trigger: 'blur' }],
        creditServiceAmount: [{ required: true, message: '请输入大数据信用信息服务业务', trigger: 'blur' }],
        creditManagementServiceAmount: [{ required: true, message: '请输入信用管理咨询业务', trigger: 'blur' }],
        // 业务
        companyCreditReportNumber: [{ required: true, message: '请输入信用报告出具数', trigger: 'blur' }],
        companyOtherCreditProductNumber: [{ required: true, message: '请输入其他征信服务产品提供次数', trigger: 'blur' }],
        companyCustomerNumber: [{ required: true, message: '请输入客户数量', trigger: 'blur' }],
        personalCreditReportNumber: [{ required: true, message: '请输入信用报告出具数', trigger: 'blur' }],
        personalCustomerNumber: [{ required: true, message: '请输入客户数量', trigger: 'blur' }],
        socialGovernmentProjectNumber: [{ required: true, message: '请输入服务政府项目数', trigger: 'blur' }],
        industryServiceIndustryNumber: [{ required: true, message: '请输入服务行业协会项目数', trigger: 'blur' }],
        industryRatingNumber: [{ required: true, message: '请输入评价数量', trigger: 'blur' }],
        industryServiceIndustryNumber: [{ required: true, message: '请输入评价数量', trigger: 'blur' }],
        structuredRatingNumber: [{ required: true, message: '请输入评价数量', trigger: 'blur' }],
        sovereignRatingNumber: [{ required: true, message: '请输入评价数量', trigger: 'blur' }],
        financialRatingNumber: [{ required: true, message: '请输入评价数量', trigger: 'blur' }],
        publicRatingNumber: [{ required: true, message: '请输入评价数量', trigger: 'blur' }],
        guaranteeNumber: [{ required: true, message: '请输入担保数量', trigger: 'blur' }],
        totalGuaranteeAmount: [{ required: true, message: '请输入担保金额合计', trigger: 'blur' }],
        bankFactoringNumber: [{ required: true, message: '请输入保理业务发生笔数', trigger: 'blur' }],
        bankFactoringIncurredAmount: [{ required: true, message: '请输入保理业务发生额', trigger: 'blur' }],
        commercialFactoringNumber: [{ required: true, message: '请输入保理业务发生笔数', trigger: 'blur' }],
        commercialFactoringIncurredAmount: [{ required: true, message: '请输入保理业务发生额', trigger: 'blur' }],
        commercialPoliciesNumber: [{ required: true, message: '请输入保单数', trigger: 'blur' }],
        commercialTotalInsuredAmount: [{ required: true, message: '请输入承保金额合计', trigger: 'blur' }],
        exportPoliciesNumber: [{ required: true, message: '请输入保单数', trigger: 'blur' }],
        exportTotalInsuredAmount: [{ required: true, message: '请输入承保金额合计', trigger: 'blur' }],
        totalEntrustmentAmount: [{ required: true, message: '请输入应收账委托金额合计', trigger: 'blur' }],
        totalReceivablesAmount: [{ required: true, message: '请输入应收账款回收金额合计', trigger: 'blur' }],
        creditCleaningCustomerNumber: [{ required: true, message: '请输入服务客户数', trigger: 'blur' }],
        creditAnalysisCustomerNumber: [{ required: true, message: '请输入服务客户数', trigger: 'blur' }],
        internetServiceCustomerNumber: [{ required: true, message: '请输入服务客户数', trigger: 'blur' }],
        creditApplicationCustomerNumber: [{ required: true, message: '请输入服务客户数', trigger: 'blur' }],
        creditTrainingSession: [{ required: true, message: '请输入培训场次', trigger: 'blur' }],
        creditTotalTrainingPerson: [{ required: true, message: '请输入培训人次合计', trigger: 'blur' }],
        creditMonitoredWarningNumber: [{ required: true, message: '请输入当年被预警监测企业数', trigger: 'blur' }],
        creditCustomerWarningNumber: [{ required: true, message: '请输入当年预警服务的客户数', trigger: 'blur' }],
        creditManagementCustomerNumber: [{ required: true, message: '请输入服务客户数', trigger: 'blur' }],

      },
      // 修改前数据
      oldDataBeforeChange: {

      },
      busVisible: false,
      busStatus: 1, // 1添加 2修改
      busForm: {
        address: "",
        province: '',
        city: '',
        area: '',
        street: ''
      },
      editIndex: '',
      busFormRules: {
        street: [
          { required: true, message: '单位经营地及区划地址', trigger: 'blur' }
        ],
      },
      applyVisible: false,
      reasonPrams: {
        id: '',
        applyStatus: '',
        comment: ''
      },
      // 提交审核中不显示编辑
      approverStatusTe: '',
      flag: false,   //true管理员调查表不展示  false展示
      quesList: [],  //管理员调查表list
      yearList: [],
      remarkReason: "",
      isShowData: 0, // 管理员是否显示暂无调查表信息 0不显示 1显示
      fixTimer: null,
      unitInfoArr: [],
      nextUnitPageNumber: 1,
      nextUnitPageSize: 4,
      nextUnitTotal: 0,
      // 判断人数与年末总人数不符合
      sumNoMatch1: false,
      sumNoMatch2: false,
      // 下一级法人单位
      legalPerNextVisible: false,
      legalPerNextFormStatus: 1, // 1添加 2修改
      editlegalPerNextIndex: '',
      legalPerNextForm: {
        contactPhone: "",
        // createTime: "",
        // createUserId: "",
        // delTag: 0,
        // id: "",
        legalRepresentative: "",
        organizationCode: "",
        unitName: "",
        // updateTime: "",
        // updateUserId: "",
        // version: 1,
      },
      legalPerNextFormRules: {
        // street: [
        //   { required: true, message: '单位经营地及区划地址', trigger: 'blur' }
        // ],
      },
      alreadyPassVisible: false,
    }
  },
  created() {
    this.adminPower = ((this.roleType == 2 && this.$route.name == 'AdminApplication') || (this.roleType == 3 && this.$route.name == 'Application'))
    this.getQuestionnaireInfo()


  },
  mounted() {
    window.onscroll = this.debounce(this.handleScroll, 200)
  },
  destroyed() {
    clearTimeout(this.fixTimer)
  },
  watch: {
    //singleYear:yearList

  },
  computed: {

  },
  methods: {
    // 只能输入正整数
    onlyIntVal(e, val) {
      let flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);
      if (!flag) {
        // this.situationForm[val] = e.target.value.slice(0,-1)
        this.situationForm[val] = e.target.value.replace(/([^\u0000-\u00FF]|[a-zA-Z]|[-=&*\!"~#$%^;'./,\\|])/g, '');
      }
    },
    compareNewOld(newVal, oldVal) {
      if (this.quesNaireData) {
        // 只有修改的时候显示
        if (this.quesNaireData.applyName === '调查表修改申请') {
          // 相同的时候不显示
          if (newVal == oldVal) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    // 防抖
    debounce(fn, delay) {
      this.fixTimer = null //借助闭包
      return function () {
        if (this.fixTimer) {
          clearTimeout(this.fixTimer)
        }
        this.fixTimer = setTimeout(fn, delay) // 简化写法
      }
    },
    // 调查表保存并提交固定
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // offsetTop到父级元素的距离
      var offsetTop = this.$refs.questionnaire ? (this.$refs.questionnaire.offsetTop + 460) : ""

      if (scrollTop > offsetTop) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    },
    // 任务退回
    taskBack() {
      this.$refs.backDialog.titleName = '任务退回'
      this.$refs.backDialog.refuseVisible = true
      this.$refs.backDialog.step = 1
      this.$refs.backDialog.receiveParams.id = this.quesNaireData.id
    },
    // 接受任务
    async acceptTask() {
      this.$refs.backDialog.receiveParams.id = this.quesNaireData.id
      this.$refs.backDialog.receiveParams.taskStatus = 2
      const { data } = await taskManagement(this.$refs.backDialog.receiveParams)
      if (data.code != 0) return
      this.quesNaireData.taskStatus = 2
      this.$parent.findAllTask()
      this.quesNaireData = this.$parent.taskList.find(item => item.id == this.quesNaireData.id)
    },
    submitUpload() {
    },
    beforeUpload(file) {
      let Xls = file.name.split('.');
      if (Xls[1] === 'xls' || Xls[1] === 'xlsx') {
        return file
      } else {
        this.$message.error('上传文件只能是 xls/xlsx 格式!')
        return false
      }
    },
    // 导入调查表20220809
    async httpRequest(val) {
      this.isSaveOrSubmit = 'save'
      try {
        let fd = new FormData();
        fd.append('file', val.file);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
        // 导入后30秒无响应不再等待加载
        setTimeout(() => {
          console.log('30000');
          this.$store.state.isLoading = false;
        }, 30000)
        const { data } = await importQuesInfo(fd)
        console.log('data', data);
        if (data.code == 0) {
          this.$message.success("上传文件成功!")
          this.getQuestionnaireInfo()
          this.$refs.upload.clearFiles();//解决第二次开始无法提交
        } else {
          this.$message.error(data.msg)
        }
      } catch (error) {
        this.$message.error(error.data.msg)
      }

    },
    handleYear(val) {
      // 切换年份的时候，所有还原初始
      this.activeName = '1';
      this.sumNoMatch1 = false;
      this.sumNoMatch2 = false;
      this.getQuestionnaireInfo()
    },
    navClick(val) {
      this.activeName = val.name
    },
    //查询调查表数据
    async getQuestionnaireInfo() {
      // 管理员主要业务活动展示--置空
      this.checkedOneShow = false;
      this.checkedTwoShow = false;
      this.checkedThreeShow = false;
      this.checkedFourShow = false;
      this.checkedFiveShow = false;
      this.checkedSixShow = false;
      this.checkedSevenShow = false;
      this.checkedEightShow = false;
      this.checkedNineShow = false;
      if (this.roleType == 3 && this.$route.name == 'Management') {
        this.yearList = this.yearData.length == 0 ? sessionStorage.getItem('yearT').split(',') : JSON.parse(JSON.stringify(this.yearData))
        this.yearList.sort(function (a, b) {
          return a > b ? -1 : 1
        })
      }
      if (this.$route.name == 'Management') {
        if (this.roleType == 2) {
          this.quesParams.createUserId = this.$route.query.id
          this.quesParams.year = ''
        } else if (this.roleType == 3) {
          this.quesParams.createUserId = this.userId
          if (this.yearList != null) {
            if (this.yearValue == 0) {
              this.quesParams.year = this.yearList[0]
            } else if (this.yearValue == 1) {
              this.quesParams.year = this.yearList[1]
            } else if (this.yearValue == 2) {
              this.quesParams.year = this.yearList[2]
            } else if (this.yearValue == 3) {
              this.quesParams.year = this.yearList[3]
            } else if (this.yearValue == 4) {
              this.quesParams.year = this.yearList[4]
            }
          }
        }
      }
      // 从“我的提醒”点击过来的
      if (this.roleType == 2 && this.$route.query.remindType == 5) {
        this.isLoading = true;
      }

      try {
        const { data } = await questionnaireInfo(this.quesParams)
        // console.log("data", data);
        this.isLoading = false
        if (data.code != 0) return;
        if (data.questionnaireDtoList && data.questionnaireDtoList.length > 0) {
          data.questionnaireDtoList = data.questionnaireDtoList.sort((a, b) => {
            return b.year - a.year
          })
        }
        // 查看
        if ((this.roleType == 2 && this.$route.name == 'AdminApplication') || (this.roleType == 3 && this.$route.name == 'Application')) {
          this.situationForm = {
            ...JSON.parse(this.quesNaireData.param),
            product: [],
            busAddress: []
          }
          // 获取修改前数据
          this.findQuesInfoBackData(this.quesNaireData.id)
          this.singleYear = [JSON.parse(this.quesNaireData.param).year]
          let arrayYear = [JSON.parse(this.quesNaireData.param).year]
          this.singleYear.sort(function (x, y) {
            return x > y ? -1 : 1;
          });
          this.isEdit = false
          this.isSave = false
          this.isSubmit = false
          this.isDisabled = true
          this.remarkReason = JSON.parse(this.quesNaireData.param).remark ? JSON.parse(this.quesNaireData.param).remark : "";

          if (this.situationForm.openTime === 'Invalid Date' || this.situationForm.openTime === null) {
            this.situationForm.openTime = ''
          } else {
            this.situationForm.openTime = this.$dayjs(this.situationForm.openTime).format('YYYY-MM-DD')
          }
        }
        // 操作
        else if (this.$route.name == 'Management') {
          // 会员
          if (this.roleType == 3) {
            this.situationForm = JSON.parse(JSON.stringify(data.questionnaireDtoList))[0]
            this.approverStatusTe = this.situationForm == null ? null : this.situationForm.approveStatus
            // 什么状态都没有的最初始状态，全部可填
            if ((this.situationForm.approveStatus == null && this.situationForm.saveType == null)) {
              this.situationForm.operationType = 1
              this.isEdit = false
              this.isSave = true
              this.isSubmit = true
              this.isDisabled = false
            }
            // 有保存或者提交状态，编辑可点，其他不可
            else {
              this.situationForm.operationType = 2
              // 如果是可编辑状态下，点击的是保存或导入
              if (!this.isEdit && this.isSaveOrSubmit == 'save') {
                this.isEdit = false
                this.isSave = true
                this.isSubmit = true
                this.isDisabled = false
              }
              // 如果是可编辑状态下，点击的是保存并提交
              else {
                this.isEdit = true
                this.isSave = false
                this.isSubmit = false
                this.isDisabled = true
              }
            }
          }
          // 管理员
          else if (this.roleType == 2) {
            this.quesList = JSON.parse(JSON.stringify(data.questionnaireDtoList))
            if (this.quesList.length > 0 && this.quesList[0].year != null) {
              this.isShowData = 0
              if (this.quesList.length == 1) {
                this.quesList.forEach((item, index) => {
                  if (item.year != null && item.approveStatus == 5) {
                    this.yearList = this.yearData.filter((val, i) => val == item.year)
                    this.yearList.sort(function (a, b) {
                      return a > b ? -1 : 1
                    })
                  }
                })
              } else {
                this.yearList = this.quesList.map(item => item.year)
                this.yearList.sort(function (a, b) {
                  return a > b ? -1 : 1
                })
              }
            } else {
              this.isShowData = 1
            }
            if (this.yearValue == 0) {
              this.situationForm = this.quesList[0]
            } else if (this.yearValue == 1) {
              this.situationForm = this.quesList[1]
            } else if (this.yearValue == 2) {
              this.situationForm = this.quesList[2]
            } else if (this.yearValue == 3) {
              this.situationForm = this.quesList[3]
            } else if (this.yearValue == 4) {
              this.situationForm = this.quesList[4]
            }

            // this.isEdit = true
            // this.isSave = false
            // this.isSubmit = false
            // this.isDisabled = true




          }

          this.situationForm = {
            ...JSON.parse(JSON.stringify(this.situationForm ? this.situationForm : '')),
            product: [],
            busAddress: []
          }
          if (this.situationForm.openTime === 'Invalid Date' || this.situationForm.openTime === null) {
            this.situationForm.openTime = ''
          } else {
            this.situationForm.openTime = this.$dayjs(this.situationForm.openTime).format('YYYY-MM-DD')
          }
        }
        // 下一级法人单位情况：
        this.unitInfoArr = this.situationForm.unitInformationDtoList ? this.situationForm.unitInformationDtoList.slice(0, 4) : []
        this.nextUnitTotal = this.situationForm.unitInformationDtoList ? this.situationForm.unitInformationDtoList.length : 0;

        // 处理地址
        if (this.situationForm.businessAddress == null) {
          this.situationForm.busAddress = []
        } else {
          if (this.situationForm.businessAddress.includes("[")) {
            this.situationForm.busAddress = JSON.parse(this.situationForm.businessAddress)
            this.situationForm.busAddress.forEach((item, index) => {
              if (!item.address) {
                this.situationForm.busAddress[index] = {
                  address: item
                }
              }
            })
          } else {
            this.situationForm.busAddress.push({ address: this.situationForm.businessAddress })
          }
        }

        // 处理业务类型

        if (this.situationForm.businessType == null) {
          this.situationForm.product = []
        } else {
          this.situationForm.product = this.businessTypeHandle(this.situationForm.businessType)

        }
        // 管理员只显示选中的--主要业务活动
        if (this.roleType == 2) {

          this.situationForm.product.forEach((item, index) => {
            if (item == '信用调查与服务') {
              this.checkedOneShow = true
            } else if (item == '公共信用管理服务') {
              this.checkedTwoShow = true
            } else if (item == '信用评价') {
              this.checkedThreeShow = true
            } else if (item == '信用担保') {
              this.checkedFourShow = true
            } else if (item == '保理') {
              this.checkedFiveShow = true
            } else if (item == '信用保险服务') {
              this.checkedSixShow = true
            } else if (item == '商账管理服务') {
              this.checkedSevenShow = true
            } else if (item == '大数据信用信息服务') {
              this.checkedEightShow = true
            } else if (item == '信用管理咨询') {
              this.checkedNineShow = true
            }
          })
        }
        // 处理公司名字
        if (this.situationForm.companyName == null) {
          if (this.roleType == 3) {
            this.situationForm.companyName = JSON.parse(sessionStorage.getItem('userInfo')).memberUnitName
          } else if (this.roleType == 2) {
            this.situationForm.companyName = this.$route.query.comName
          }
        }
        // console.log('查看数据');
        // console.log(this.situationForm);


      } catch (error) {
        // this.$message.error(error.data.msg)
      }
    },
    // 处理业务类型
    businessTypeHandle(params) {
      var businessTypeStr = params
      businessTypeStr = businessTypeStr.replace(/['"\[\]]/g, '');//把所有符号都去掉
      businessTypeStr = businessTypeStr.replace(/[(\；)|(\;)|(\，)|(\,)|(\、)]/g, ',').split(',');//去掉所有逗号分号，再转成数组
      return businessTypeStr
    },
    // 查询修改前数据
    async findQuesInfoBackData(id) {
      try {

        const { data } = await findQuestionnaireInfoBack(id)
        console.log(data);
        if (data.code != 0) {
          this.$message.error(data.msg)
        } else {

          if (data.oldData != null) {
            this.oldDataBeforeChange = data.oldData;
            // 处理业务类型
            if (this.oldDataBeforeChange.businessType) {
              this.oldDataBeforeChange.product = this.businessTypeHandle(this.oldDataBeforeChange.businessType)
            }
            // 处理开业(成立)时间
            if (this.oldDataBeforeChange.openTime === 'Invalid Date' || this.oldDataBeforeChange.openTime === null) {
              this.oldDataBeforeChange.openTime = ''
            } else {
              this.oldDataBeforeChange.openTime = this.$dayjs(this.oldDataBeforeChange.openTime).format('YYYY-MM-DD')
            }
            // 处理地址
            if (this.oldDataBeforeChange.businessAddress == null) {
              this.oldDataBeforeChange.busAddress = []
            } else {
              if (this.oldDataBeforeChange.businessAddress.includes("[")) {
                this.oldDataBeforeChange.busAddress = JSON.parse(this.oldDataBeforeChange.businessAddress)
                this.oldDataBeforeChange.busAddress.forEach((item, index) => {
                  if (!item.address) {
                    this.oldDataBeforeChange.busAddress[index] = {
                      address: item
                    }
                  }
                })
              } else {
                console.log(this.oldDataBeforeChange.busAddress);
                this.oldDataBeforeChange.busAddress = []
                this.oldDataBeforeChange.busAddress.push({ address: this.oldDataBeforeChange.businessAddress })
              }
            }
          }
        }
        // console.log('修改前数据');
        // console.log(this.oldDataBeforeChange);


      } catch (error) {
        // console.log(error);
        // this.$message.error(error.data.msg)
      }


    },
    // 下一级法人单位情况：分页
    nextUnitChange(val) {
      this.nextUnitPageNumber = val
      this.unitInfoArr = this.situationForm.unitInformationDtoList.slice((val - 1) * 4, val * 4);
    },
    editInfo() {
      // 已经通过了的调查表，当会员点击【编辑】时就弹出弹框
      if (this.approverStatusTe == 5) {
        this.alreadyPassVisible = true;
      } else {
        this.isDisabled = false
        this.isSave = true
        this.isEdit = false
        this.isSubmit = true
      }

    },
    // 已经通过了的调查表，当会员点击【编辑】时就弹出弹框
    alreadyPassSure() {
      this.isDisabled = false
      this.isEdit = false
      this.isSave = true
      this.isSubmit = true
      this.alreadyPassVisible = false;
      // 状态重置
      this.alreadyPassReset()
    },
    // 已经通过了的调查表，再次编辑时重置
    alreadyPassReset() {
      // try {
      this.situationForm.remark = ''
      this.situationForm.year = this.yearList[this.yearValue]
      this.situationForm.openTime = new Date(this.situationForm.openTime).getTime(this.situationForm.openTime)
      this.situationForm.saveType = 1
      this.situationForm.approveStatus = 0

      this.commonQuesInfo()

    },
    async saveInfo(year, index) {
      this.isSaveOrSubmit = 'save'
      try {
        this.situationForm.openTime = new Date(this.situationForm.openTime).getTime()
        this.situationForm.year = year
        this.situationForm.saveType = 1
        const { data } = await addOrUpdateQuestionnaireInfo(this.situationForm)
        if (data.code != 0) {
          this.$message.error(data.msg)
        } else {
          this.$message.success("保存成功")
          this.getQuestionnaireInfo()
          this.nextUnitPageNumber = 1
        }


      } catch (error) {
        this.$message.error(error.data.msg)
      }


    },
    // 提交保存的时候判断三个模块的人数和是否和年末从业人数一致
    judgeSumMatch() {
      // 按学历分:
      var total1 = Number(this.situationForm.masterDegreeOrAboveNumber) + Number(this.situationForm.bachelorDegreeNumber) + Number(this.situationForm.collegeDegreeNumber) + Number(this.situationForm.highSchoolDegreeOrBelowNumber)
      if (total1 != Number(this.situationForm.employeesYearEndNumber)) {
        this.activeName = '2'
        this.sumNoMatch1 = true;

      } else {
        this.sumNoMatch1 = false;
      }
      // 按从业年限分:
      var total2 = Number(this.situationForm.fiveYearAndAboveNumber) + Number(this.situationForm.threeYearsFiveNumber) + Number(this.situationForm.oneYearThreeNumber) + Number(this.situationForm.followingYearNumber)
      if (total2 != Number(this.situationForm.employeesYearEndNumber)) {
        this.activeName = '2'
        this.sumNoMatch2 = true;

      } else {
        this.sumNoMatch2 = false;
      }

    },
    // 公共保存并提交接口
    async commonQuesInfo() {
      const { data } = await addOrUpdateQuestionnaireInfo(this.situationForm)
      if (data.code == 0) {
        this.$refs.reasonDialog.submitVisible = false
        this.getQuestionnaireInfo()
      } else {
        this.$message.error(data.msg)
      }
    },
    // 保存并提交
    submitInfo(year, index) {
      this.isSaveOrSubmit = 'submit'
      try {
        this.situationForm.remark = ''
        this.situationForm.year = year
        this.situationForm.openTime = new Date(this.situationForm.openTime).getTime(this.situationForm.openTime)
        this.$refs.situationForm[index].validate(async (valid, invalidFields) => {
          if (valid) {
            this.judgeSumMatch();
            if (!this.sumNoMatch1 && !this.sumNoMatch2) {
              this.situationForm.saveType = 2
              if (this.situationForm.approveStatus == 0) {
                this.$refs.reasonDialog.submitVisible = true
              } else {
                this.commonQuesInfo()
              }
            } else {
              this.$message.error('请补全调查表所有的必填项之后再提交!')
              this.scrollView(invalidFields)
            }

          } else {
            this.$message.error('请补全调查表所有的必填项之后再提交!')
            this.scrollView(invalidFields)
            this.validateSubmitItem(invalidFields);

          }
        })
      } catch (error) {
        this.message.error(data.msg)
      }
    },
    // 提交的时候，判断必填项是否为空，为空则跳转到对应模块
    validateSubmitItem(invalidFields) {
      for (var itemName in invalidFields) {
        // 基本情况
        if (itemName == 'companyName' || itemName == 'product' || itemName == 'busAddress' || itemName == 'legalRepresentative' || itemName == 'openTime') {
          this.activeName = '1'
          return
        }
        // 财务状况
        else if (itemName == 'creditInvestigationServiceAmount'
          || itemName == 'publicCreditManagementServiceAmount'
          || itemName == 'creditRatingServiceAmount'
          || itemName == 'creditGuaranteeBusinessAmount'
          || itemName == 'commercialFactoringAmount'
          || itemName == 'creditInsuranceServiceAmount'
          || itemName == 'businessAccountManagementServiceAmount'
          || itemName == 'creditServiceAmount'
          || itemName == 'creditManagementServiceAmount') {
          this.activeName = '3'
          return
        }
        // 业务状况
        else if (itemName == 'companyCreditReportNumber'
          || itemName == 'companyOtherCreditProductNumber'
          || itemName == 'companyCustomerNumber'
          || itemName == 'personalCreditReportNumber'
          || itemName == 'personalCustomerNumber'
          || itemName == 'socialGovernmentProjectNumber'
          || itemName == 'industryServiceIndustryNumber'
          || itemName == 'industryRatingNumber'
          || itemName == 'industryServiceIndustryNumber'
          || itemName == 'structuredRatingNumber'
          || itemName == 'sovereignRatingNumber'
          || itemName == 'financialRatingNumber'
          || itemName == 'publicRatingNumber'
          || itemName == 'guaranteeNumber'
          || itemName == 'totalGuaranteeAmount'
          || itemName == 'bankFactoringNumber'
          || itemName == 'bankFactoringIncurredAmount'
          || itemName == 'commercialFactoringNumber'
          || itemName == 'commercialFactoringIncurredAmount'
          || itemName == 'commercialPoliciesNumber'
          || itemName == 'commercialTotalInsuredAmount'
          || itemName == 'exportPoliciesNumber'
          || itemName == 'exportTotalInsuredAmount'
          || itemName == 'totalEntrustmentAmount'
          || itemName == 'totalReceivablesAmount'
          || itemName == 'creditCleaningCustomerNumber'
          || itemName == 'creditAnalysisCustomerNumber'
          || itemName == 'internetServiceCustomerNumber'
          || itemName == 'creditApplicationCustomerNumber'
          || itemName == 'creditTrainingSession'
          || itemName == 'creditTotalTrainingPerson'
          || itemName == 'creditMonitoredWarningNumber'
          || itemName == 'creditCustomerWarningNumber'
          || itemName == 'creditManagementCustomerNumber') {
          this.activeName = '4'
          return
        }
      }

    },
    // 滚动到固定地方
    scrollView(object) {
      for (const i in object) {

        let dom = this.$refs[i]
        // 这里是针对遍历的情况（多个输入框），取值为数组
        if (Object.prototype.toString.call(dom) !== '[object Object]') {
          dom = dom[0]
        }
        // 第一种方法（包含动画效果）
        dom.$el.scrollIntoView({ // 滚动到指定节点
          // 值有start,center,end，nearest，当前显示在视图区域中间
          block: 'center',
          // 值有auto、instant,smooth，缓动动画（当前是慢速的）
          behavior: 'smooth'
        })
        break // 因为我们只需要检测一项,所以就可以跳出循环了
      }
    },
    timeChange(time) {
      this.situationForm.openTime = new Date(time).getTime();
    },
    productChange(val) {
      this.situationForm.businessType = JSON.stringify(val)

    },
    oneChange(val) {
      this.checkedOne = val
    },
    twoChange(val) {
      this.checkedTwo = val
    },
    threeChange(val) {
      this.checkedThree = val

    },
    fourChange(val) {
      this.checkedFour = val

    },
    fiveChange(val) {
      this.checkedFive = val

    },
    sixChange(val) {
      this.checkedSix = val

    },
    sevenChange(val) {
      this.checkedSeven = val

    },
    eightChange(val) {
      this.checkedEight = val

    },
    nineChange(val) {
      this.checkedNine = val

    },
    addBusAddressData() {
      this.busVisible = true
      this.busStatus = 1
      this.busForm = {}
    },
    addBusAddress() {

      this.$refs.busForm.validate(valid => {
        if (valid) {
          if (this.busStatus == 1) {
            this.situationForm.busAddress.push(JSON.parse(JSON.stringify(this.busForm)))
          } else if (this.busStatus == 2) {
            this.situationForm.busAddress[this.editIndex] = this.busForm
          }
          this.busForm = {}
          this.busVisible = false

        }
      })
      this.situationForm.businessAddress = JSON.stringify(this.situationForm.busAddress)
    },
    editBusAddressData(row, index) {
      this.busStatus = 2
      this.editIndex = index
      this.busForm = JSON.parse(JSON.stringify(row))
      console.log(this.busForm);
      this.busVisible = true
    },
    deleteBusAddressData(row, index) {
      this.situationForm.busAddress.splice(index, 1)
    },
    // 下一级法人单位情况 操作
    // 添加
    addLegalPerNext() {
      this.legalPerNextVisible = true;
      this.legalPerNextFormStatus = 1
      this.legalPerNextForm = {
        contactPhone: "",
        // createTime: "",
        // createUserId: "",
        // delTag: 0,
        // id: "",
        legalRepresentative: "",
        organizationCode: "",
        unitName: "",
        // updateTime: "",
        // updateUserId: "",
        // version: 1,
      }
    },
    // 修改弹框
    editLegalPerNext(row, index) {
      this.legalPerNextVisible = true;
      this.legalPerNextFormStatus = 2
      this.editlegalPerNextIndex = index
      this.legalPerNextForm = JSON.parse(JSON.stringify(row))
    },
    // 确认提交
    legalPerNextSubmit() {
      this.$refs.legalPerNextForm.validate(valid => {
        if (valid) {
          // 添加
          if (this.legalPerNextFormStatus == 1) {


            this.situationForm.unitInformationDtoList.push(JSON.parse(JSON.stringify(this.legalPerNextForm)))
          }
          // 修改
          else if (this.legalPerNextFormStatus == 2) {
            this.situationForm.unitInformationDtoList[this.editlegalPerNextIndex] = this.legalPerNextForm
          }
          this.legalPerNextForm = {
            contactPhone: "",
            // createTime: "",
            // createUserId: "",
            // delTag: 0,
            // id: "",
            legalRepresentative: "",
            organizationCode: "",
            unitName: "",
            // updateTime: "",
            // updateUserId: "",
            // version: 1,
          }
          this.legalPerNextVisible = false

        }
      })
      // this.situationForm.unitInformationDtoList = JSON.stringify(this.situationForm.unitInformationDtoList)
      // 下一级法人单位情况：
      this.unitInfoArr = this.situationForm.unitInformationDtoList ? this.situationForm.unitInformationDtoList.slice(0, 4) : []
      this.nextUnitTotal = this.situationForm.unitInformationDtoList ? this.situationForm.unitInformationDtoList.length : 0;
    },
    // 删除
    deleteLegalPerNext(row, index) {
      this.situationForm.unitInformationDtoList.splice(index, 1)
      // 下一级法人单位情况：
      this.unitInfoArr = this.situationForm.unitInformationDtoList ? this.situationForm.unitInformationDtoList.slice(0, 4) : []
      this.nextUnitTotal = this.situationForm.unitInformationDtoList ? this.situationForm.unitInformationDtoList.length : 0;
    },
    selectPickerOne(a) {
      this.busForm.address = a.province.value + ',' + a.city.value + ',' + a.area.value
    },
    inputOneChange(val) {
      this.busForm.address = JSON.parse(JSON.stringify(this.busForm.address)) + ',' + val
    },
    async isSuccess(status) {
      this.reasonPrams.id = this.quesNaireData ? this.quesNaireData.id : ''
      this.reasonPrams.applyStatus = status
      const { data } = await applyRecord(this.reasonPrams)
      if (data.code != 0) return
      this.$parent.tabIndex = 0
      this.$parent.findAllTask()
    },
    closeApplyDialog() {
      this.reasonPrams.comment = ''
    },
    // 显示导入调查表提示
    showTips() { },
  },
  components: {
    BackDialog,
    ReasonDialog,
    Loading
  }
}
</script>
<style lang='less' scoped>
#questionnaire {
  padding: 0 25px;
  .backTop {
    width: 100%;
    height: 100%;
    background-color: #f2f4f6;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    text-align: center;
    line-height: 20px;
    font-size: 16px;
    color: #1989fa;
  }
  .quesstion-nocompulete-tag {
    display: inline-block;
    padding: 0 30px 0 10px;
    height: 30px;
    line-height: 30px;
    border-radius: 5px;
    border: 1px solid #84b5e5;
    background-color: #dce8f6;
    .el-icon-warning {
      color: #0066cb;
      font-size: 16px;
    }
  }
  /deep/.tabsItem {
    .title {
      padding-top: 15px;
      font-size: 16px;
      color: #333333;
      font-weight: 550;
      .el-col:nth-child(2) {
        text-align: right;
        // span {
        //   margin-left: 10px;
        // }
        .save {
          background-image: linear-gradient(-45deg, #0566cc 0%, #3793f4 100%);
          color: #fff;
        }
      }
      .export {
        width: 120px;
        margin: 0 10px 0 30px;
      }
      .el-button {
        line-height: 0;
      }
      .el-button:hover {
        background: #fff;
      }
      .titleLeft {
        display: flex;
        align-items: center;
        div[class^="quesstion"] {
          display: inline-block;
          font-weight: 500;
          margin-left: 15px;
          height: 30px;
          line-height: 30px;
          // border: 1px solid #db3b1e;
          border-radius: 5px;
          // background: #f1e3e3;
          i {
            display: inline-block;
            margin: 0 5px 0 10px;
            // color: #db3b1e;
          }
        }
        .quesstionRefuse {
          width: 40%;
          border: 1px solid #db3b1e;
          background: #f1e3e3;
          .el-icon-warning {
            color: #db3b1e;
          }
        }
        .quesstionPass {
          width: 25%;
          border: 1px solid #0dd0bf;
          background: #dff1f5;
          .el-icon-success {
            color: #0dd0bf;
          }
        }
      }
    }
    .isFixed {
      position: fixed;
      width: 72%;
      padding: 20px;
      background-color: #fff;
      top: 0;
      z-index: 999;
      border-radius: 3px;
    }
    .el-upload-list__item-name {
      display: none;
    }
    .el-button {
      border: 1px solid #dcdfe6;
    }
    .el-button.btn-disabled {
      cursor: not-allowed;
      color: #bcbec2;
      background-color: #f4f4f5;
      border-color: #e9e9eb;
    }
    .quesTips {
      border-color: #0066cc;
      font-size: 15px;
      width: 35%;
      text-align: left;
      .el-icon-warning {
        color: #0066cc;
      }
    }
  }
  /deep/.noneUpload {
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
      display: none;
    }
  }
  .noInfo {
    margin: 50px;
    font-size: 18px;
    text-align: center;
    line-height: 43px;
    color: #333;
    img {
      vertical-align: middle;
      margin-right: 20px;
    }
  }
  // 样式管理员可见
  /deep/.escTabs {
    .el-tabs__header {
      display: none;
    }
    #nav {
      .el-tabs__header {
        display: block;
      }
    }
  }

  /deep/#nav {
    .content {
      text-align: center;
      width: 100%;
      display: inline-block;
      // border-right: 1px dashed #cdcdcd;
      img {
        width: 36px;
        vertical-align: middle;
        padding-right: 15px;
      }
    }
    .el-tabs__item {
      color: #303133;
    }
    .el-tabs__item.is-active {
      color: #409eff;
    }

    .el-tabs__header {
      margin: 0 0 15px !important;
    }
  }
  .fare {
    border-right: none;
  }
  /deep/.itemCommon {
    .el-input {
      width: 70%;
      padding-right: 10px;
    }
    .el-textarea {
      width: 95%;
    }
    .el-checkbox-group {
      font-size: 14px;
    }
    .wenhao {
      width: 16px;
      vertical-align: middle;
    }
    .el-textarea__inner {
      width: 31%;
    }
  }
  /deep/.mainProduct {
    .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: #333;
    }
  }
  /deep/.el-textarea__inner {
    background: #f3f6f9;
  }
  .tips {
    display: inline-block;
    color: rgb(153, 153, 153);
    font-weight: 400;
    font-size: 14px;
  }
  .edit {
    display: inline-block;
    margin-right: 15px;
  }
  /deep/.situationForm {
    .before-changes-item {
      color: #999;
      margin: 0 10px;
      display: inline-block;
      vertical-align: top;
    }
    .before-changes-item.product-fixed {
      position: absolute;
      left: 230px;
      top: 0;
    }
    .changes-item-fixedw {
      display: inline-block;
      width: 230px;
      word-break: break-all;
      line-height: 22px;
      vertical-align: text-top;
    }
    .itemOne {
      .el-form-item__label {
        width: 119px !important;
      }
      .el-input__inner {
        width: 50%;
      }
    }
    // .itemThree {
    // .el-form-item__label {
    // width: 200px !important;
    // }
    // }
    .itemFive {
      .el-form-item__label {
        width: 123px !important;
      }
    }
    .congye {
      position: relative;
      padding-left: 17px;
      h4 {
        margin-bottom: 15px;
      }
      .el-input {
        width: 70%;
        margin-right: 10px;
      }
      .line {
        position: absolute;
        display: inline-block;
        height: 80%;
        border-left: dashed 2px #cdcdcd;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .congyeColtwo {
        padding-left: 50px;
      }
      .sumNo-match {
        color: #f56c6c;
        font-size: 12px;
      }
    }
    .titleTwo {
      padding-left: 10px;
      margin-bottom: 20px;
      border-left: 5px solid #0566cc;
    }
  }
  // 基础信息单位地址
  /deep/.busVisible {
    .el-input {
      width: 98% !important;
      .el-input__inner {
        background: #fff !important;
      }
    }
    .address {
      margin-top: 10px;
    }
    .distpicker-address-wrapper select {
      background-color: #fff !important;
      width: 176px;
    }
  }
  /deep/.addInfoVisible {
    .el-textarea__inner {
      background: #fff;
    }
  }
  .quesTips {
    .textTips {
      color: #666666;
    }
  }
}
</style>